import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, HostBinding, NgModule, EventEmitter, ViewChild, Output, HostListener, forwardRef, TemplateRef, Type, Injector, InjectionToken, Inject, Directive, ContentChildren, ViewContainerRef, Pipe, ContentChild } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i3$1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ComponentPortal } from '@angular/cdk/portal';
import { Subject, timer, from, merge, fromEvent } from 'rxjs';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { takeUntil, take, first, startWith, switchMap, filter } from 'rxjs/operators';
import * as i1 from '@angular/cdk/overlay';
import { OverlayModule, Overlay } from '@angular/cdk/overlay';
import * as i3 from '@angular/platform-browser';
import { clone, union } from 'lodash';
import * as i6 from '@angular/cdk/scrolling';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';

var IStatus;
(function (IStatus) {
    IStatus["primary"] = "primary";
    IStatus["secondary"] = "secondary";
    IStatus["success"] = "success";
    IStatus["danger"] = "danger";
    IStatus["warning"] = "warning";
    IStatus["info"] = "info";
    IStatus["light"] = "light";
    IStatus["dark"] = "dark";
    IStatus["transparent"] = "transparent";
})(IStatus || (IStatus = {}));
var ISize$1;
(function (ISize) {
    ISize["xs"] = "xs";
    ISize["sm"] = "sm";
    ISize["base"] = "base";
    ISize["lg"] = "lg";
    ISize["xl"] = "xl";
})(ISize$1 || (ISize$1 = {}));
var ITextSize;
(function (ITextSize) {
    ITextSize["xs"] = "xs";
    ITextSize["sm"] = "sm";
    ITextSize["base"] = "base";
    ITextSize["lg"] = "lg";
    ITextSize["xl"] = "xl";
    ITextSize["2xl"] = "2xl";
    ITextSize["3xl"] = "3xl";
    ITextSize["4xl"] = "4xl";
    ITextSize["5xl"] = "5xl";
    ITextSize["6xl"] = "6xl";
    ITextSize["7xl"] = "7xl";
    ITextSize["8xl"] = "8xl";
    ITextSize["9xl"] = "9xl";
})(ITextSize || (ITextSize = {}));
const FILL_COLOR = {
    "danger": 'fill-danger',
    "dark": 'fill-dark',
    "info": 'fill-info',
    "light": 'fill-light',
    "primary": 'fill-primary',
    "secondary": 'fill-secondary',
    "success": 'fill-success',
    "warning": 'fill-warning',
    "transparent": "fill-transparent"
};
const TEXT_COLOR = {
    "danger": 'text-danger',
    "dark": 'text-dark',
    "info": 'text-info',
    "light": 'text-light',
    "primary": 'text-primary',
    "secondary": 'text-secondary',
    "success": 'text-success',
    "warning": 'text-warning',
    "transparent": "text-transparent"
};
const BACKGROUND_COLOR = {
    "danger": 'bg-danger',
    "dark": 'bg-dark',
    "info": 'bg-info',
    "light": 'bg-light',
    "primary": 'bg-primary',
    "secondary": 'bg-secondary',
    "success": 'bg-success',
    "warning": 'bg-warning',
    "transparent": "bg-transparent"
};
const TEXT_SIZE = {
    "xs": 'text-xs',
    "sm": 'text-sm',
    "base": 'text-base',
    "lg": 'text-lg',
    "xl": 'text-xl',
    "2xl": 'text-2xl',
    "3xl": 'text-3xl',
    "4xl": 'text-4xl',
    "5xl": 'text-5xl',
    "6xl": 'text-6xl',
    "7xl": 'text-7xl',
    "8xl": 'text-8xl',
    "9xl": 'text-9xl'
};
const PADDING_SIZE = {
    "xs": "py-0.5 px-1",
    "sm": "px-1.5 py-0.5",
    "base": "px-2.5 py-1",
    "lg": "px-3 py-2",
    "xl": "px-4 py-2.5"
};

class VlLayoutService {
    constructor() { }
    validateStatus(status) {
        return Object.values(IStatus).includes(status) ? status : "primary";
    }
    validateSize(size) {
        return Object.values(ISize$1).includes(size) ? size : "base";
    }
    validateTextSize(textSize) {
        return Object.values(ITextSize).includes(textSize) ? textSize : "base";
    }
}
VlLayoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlLayoutService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
VlLayoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlLayoutService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlLayoutService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class VlBadgeComponent {
    constructor(vlLayoutService) {
        this.vlLayoutService = vlLayoutService;
        this.status = "primary";
        this.size = "sm";
        this.cssColor = {
            "danger": `${BACKGROUND_COLOR['danger']} text-white`,
            "dark": `${BACKGROUND_COLOR['dark']} text-white`,
            "info": `${BACKGROUND_COLOR['info']} text-white`,
            "light": `${BACKGROUND_COLOR['light']} text-dark`,
            "primary": `${BACKGROUND_COLOR['primary']} text-white`,
            "secondary": `${BACKGROUND_COLOR['secondary']} text-white`,
            "success": `${BACKGROUND_COLOR['success']} text-white`,
            "warning": `${BACKGROUND_COLOR['warning']} text-white`,
        };
        this.cssSize = {
            xs: `text-xs`,
            sm: `text-sm`,
            base: `text-base`,
            lg: `text-lg`,
            xl: `text-lg`,
        };
    }
    get cssClass() {
        return `${this.cssColor[this.status]} ${this.cssSize[this.size]}`;
    }
    ngOnInit() {
        this.size = this.vlLayoutService.validateSize(this.size);
        this.status = this.vlLayoutService.validateStatus(this.status);
    }
}
VlBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlBadgeComponent, selector: "vl-badge", inputs: { status: "status", size: "size" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div [ngClass]=\"cssClass\" class=\"font-medium rounded-full w-fit inline-block py-1 px-1.5 leading-none text-center align-middle whitespace-nowrap\">\n    <ng-content></ng-content>\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"cssClass\" class=\"font-medium rounded-full w-fit inline-block py-1 px-1.5 leading-none text-center align-middle whitespace-nowrap\">\n    <ng-content></ng-content>\n</div>" }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { status: [{
                type: Input
            }], size: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlBadgeModule {
}
VlBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeModule, declarations: [VlBadgeComponent], imports: [CommonModule], exports: [VlBadgeComponent] });
VlBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlBadgeComponent
                    ],
                    exports: [
                        VlBadgeComponent
                    ]
                }]
        }] });

class VlButtonComponent {
    constructor(vlLayoutService, parentRef) {
        this.vlLayoutService = vlLayoutService;
        this.parentRef = parentRef;
        this.rounded = true;
        this.status = "primary";
        this.size = "base";
        this.disabled = false;
        this.onClick = new EventEmitter();
        this.cssColor = {
            "danger": 'bg-danger-500 hover:bg-danger-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "dark": 'bg-dark-500 hover:bg-dark-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "info": 'bg-info-500 hover:bg-info-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "light": 'bg-light-500 hover:bg-light-600 text-dark disabled:bg-light-700 disabled:text-dark/50 border',
            "primary": 'bg-primary-500 hover:bg-primary-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "secondary": 'bg-secondary-500 hover:bg-secondary-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "success": 'bg-success-500 hover:bg-success-600 text-white disabled:bg-light-700 disabled:text-dark/50',
            "warning": 'bg-warning-500 hover:bg-warning-600 text-white disabled:bg-light-700 disabled:text-dark/50',
        };
        this.cssSize = {
            xs: `${PADDING_SIZE['xs']} text-xs`,
            sm: `${PADDING_SIZE['sm']} text-sm`,
            base: `${PADDING_SIZE['base']} text-base`,
            lg: `${PADDING_SIZE['lg']} text-lg`,
            xl: `${PADDING_SIZE['xl']} text-lg`,
        };
    }
    get elementRef() {
        return this.button;
    }
    get cssClass() {
        return `${this.cssColor[this.status]} ${this.cssSize[this.size]}`;
    }
    ngOnInit() {
        this.size = this.vlLayoutService.validateSize(this.size);
        this.status = this.vlLayoutService.validateStatus(this.status);
    }
    onListnerClick(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    onClicked(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.disabled) {
            return;
        }
        this.onClick.emit(event);
    }
}
VlButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlButtonComponent, deps: [{ token: VlLayoutService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlButtonComponent, selector: "vl-button", inputs: { rounded: "rounded", status: "status", size: "size", disabled: "disabled" }, outputs: { onClick: "onClick" }, host: { listeners: { "click": "onListnerClick($event)" } }, viewQueries: [{ propertyName: "button", first: true, predicate: ["buttonRef"], descendants: true }], ngImport: i0, template: "<button #buttonRef type=\"button\" class=\"transition-colors disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\" [disabled]=\"disabled\" (click)=\"onClicked($event)\">\n   <ng-content></ng-content>\n</button>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content}:host button{overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button #buttonRef type=\"button\" class=\"transition-colors disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\" [disabled]=\"disabled\" (click)=\"onClicked($event)\">\n   <ng-content></ng-content>\n</button>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content}:host button{overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }, { type: i0.ElementRef }]; }, propDecorators: { button: [{
                type: ViewChild,
                args: ['buttonRef']
            }], rounded: [{
                type: Input
            }], status: [{
                type: Input
            }], size: [{
                type: Input
            }], disabled: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onListnerClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class VlButtonModule {
}
VlButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlButtonModule, declarations: [VlButtonComponent], imports: [CommonModule], exports: [VlButtonComponent] });
VlButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlButtonModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlButtonComponent
                    ],
                    exports: [
                        VlButtonComponent
                    ]
                }]
        }] });

class VlCardHeaderComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    tailwindClass() {
        return true;
    }
    get elementRef() {
        return this._elementRef;
    }
}
VlCardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardHeaderComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlCardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlCardHeaderComponent, selector: "vl-card-header", host: { properties: { "class": "this.class", "class.p-4": "this.tailwindClass", "class.border-b": "this.tailwindClass", "class.border-light-500": "this.tailwindClass", "class.font-semibold": "this.tailwindClass" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-card-header',
                    template: `<ng-content></ng-content>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], tailwindClass: [{
                type: HostBinding,
                args: ['class.p-4']
            }, {
                type: HostBinding,
                args: ['class.border-b']
            }, {
                type: HostBinding,
                args: ['class.border-light-500']
            }, {
                type: HostBinding,
                args: ['class.font-semibold']
            }] } });
class VlCardBodyComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    tailwindClass() {
        return true;
    }
    get elementRef() {
        return this._elementRef;
    }
}
VlCardBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardBodyComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlCardBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlCardBodyComponent, selector: "vl-card-body", host: { properties: { "class": "this.class", "class.p-4": "this.tailwindClass", "class.flex-1": "this.tailwindClass", "class.break-words": "this.tailwindClass", "class.font-normal": "this.tailwindClass" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-card-body',
                    template: `<ng-content></ng-content>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], tailwindClass: [{
                type: HostBinding,
                args: ['class.p-4']
            }, {
                type: HostBinding,
                args: ['class.flex-1']
            }, {
                type: HostBinding,
                args: ['class.break-words']
            }, {
                type: HostBinding,
                args: ['class.font-normal']
            }] } });
class VlCardFooterComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    tailwindClass() {
        return true;
    }
    get elementRef() {
        return this._elementRef;
    }
}
VlCardFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardFooterComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlCardFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlCardFooterComponent, selector: "vl-card-footer", host: { properties: { "class": "this.class", "class.p-4": "this.tailwindClass", "class.break-words": "this.tailwindClass", "class.border-t": "this.tailwindClass", "class.border-light-500": "this.tailwindClass", "class.font-normal": "this.tailwindClass" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-card-footer',
                    template: `<ng-content></ng-content>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], tailwindClass: [{
                type: HostBinding,
                args: ['class.p-4']
            }, {
                type: HostBinding,
                args: ['class.break-words']
            }, {
                type: HostBinding,
                args: ['class.border-t']
            }, {
                type: HostBinding,
                args: ['class.border-light-500']
            }, {
                type: HostBinding,
                args: ['class.font-normal']
            }] } });
class VlCardComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    tailwindClass() {
        return true;
    }
    get elementRef() {
        return this._elementRef;
    }
}
VlCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlCardComponent, selector: "vl-card", host: { properties: { "class": "this.class", "class.border": "this.tailwindClass", "class.border-light-500": "this.tailwindClass", "class.rounded-lg": "this.tailwindClass", "class.bg-white": "this.tailwindClass", "class.shadow-lg": "this.tailwindClass" } }, ngImport: i0, template: "<ng-content select=\"vl-card-header\"></ng-content>\n<ng-content select=\"vl-card-body\"></ng-content>\n<ng-content select=\"vl-card-footer\"></ng-content>\n<ng-content></ng-content>", styles: [":host{display:flex;flex-direction:column;height:-moz-fit-content;height:fit-content}:host ::ng-deep vl-card-header{overflow:hidden}:host ::ng-deep vl-card-body{position:relative;flex:1 1 0%;overflow:auto}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"vl-card-header\"></ng-content>\n<ng-content select=\"vl-card-body\"></ng-content>\n<ng-content select=\"vl-card-footer\"></ng-content>\n<ng-content></ng-content>", styles: [":host{display:flex;flex-direction:column;height:-moz-fit-content;height:fit-content}:host ::ng-deep vl-card-header{overflow:hidden}:host ::ng-deep vl-card-body{position:relative;flex:1 1 0%;overflow:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], tailwindClass: [{
                type: HostBinding,
                args: ['class.border']
            }, {
                type: HostBinding,
                args: ['class.border-light-500']
            }, {
                type: HostBinding,
                args: ['class.rounded-lg']
            }, {
                type: HostBinding,
                args: ['class.bg-white']
            }, {
                type: HostBinding,
                args: ['class.shadow-lg']
            }] } });

const COMPONENTS$7 = [
    VlCardComponent,
    VlCardHeaderComponent,
    VlCardBodyComponent,
    VlCardFooterComponent
];
class VlCardModule {
}
VlCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlCardModule, declarations: [VlCardComponent,
        VlCardHeaderComponent,
        VlCardBodyComponent,
        VlCardFooterComponent], imports: [CommonModule], exports: [VlCardComponent,
        VlCardHeaderComponent,
        VlCardBodyComponent,
        VlCardFooterComponent] });
VlCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ...COMPONENTS$7
                    ],
                    exports: [
                        ...COMPONENTS$7
                    ]
                }]
        }] });

class VlCheckboxComponent {
    constructor(elementRef, renderer, changeDetector, vlLayoutService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        this.vlLayoutService = vlLayoutService;
        this.checkedChange = new EventEmitter();
        this.status = "primary";
        this.isDisabled = false;
        this.isChecked = false;
        this.cssColor = {
            "danger": 'border-danger peer-disabled:peer-hover:bg-danger/25 peer-disabled:peer-checked:peer-hover:bg-danger bg-danger/25 peer-hover:bg-danger/50 peer-checked:bg-danger peer-checked:peer-hover:bg-danger0/50',
            "dark": 'border-dark peer-disabled:peer-hover:bg-dark/dark peer-disabled:peer-checked:peer-hover:bg-dark bg-dark/25 peer-hover:bg-dark/50 peer-checked:bg-dark peer-checked:peer-hover:bg-dark/50',
            "info": 'border-info peer-disabled:peer-hover:bg-info/25 peer-disabled:peer-checked:peer-hover:bg-info bg-info/25 peer-hover:bg-info/50 peer-checked:bg-info peer-checked:peer-hover:bg-info/50',
            "light": 'border-light peer-disabled:peer-hover:bg-light/25 peer-disabled:peer-checked:peer-hover:bg-light bg-light/25 peer-hover:bg-light/50 peer-checked:bg-light peer-checked:peer-hover:bg-light/50',
            "primary": 'border-primary peer-disabled:peer-hover:bg-primary/25 peer-disabled:peer-checked:peer-hover:bg-primary bg-primary/25 peer-hover:primary/50 peer-checked:bg-primary peer-checked:peer-hover:bg-primary/50',
            "secondary": 'border-secondary peer-disabled:peer-hover:bg-secondary/25 peer-disabled:peer-checked:peer-hover:bg-secondary bg-secondary/25 peer-hover:bg-secondary/50 peer-checked:bg-secondary peer-checked:peer-hover:bg-secondary/50',
            "success": 'border-success peer-disabled:peer-hover:bg-success/25 peer-disabled:peer-checked:peer-hover:bg-success bg-success/25 peer-hover:bg-success/50 peer-checked:bg-success peer-checked:peer-hover:bg-success/50',
            "warning": 'border-warning peer-disabled:peer-hover:bg-warning/25 peer-disabled:peer-checked:peer-hover:bg-warning bg-warning/25 peer-hover:bg-warning/50 peer-checked:bg-warning peer-checked:peer-hover:bg-warning/50'
        };
        this.cssColorLabel = {
            'danger': 'text-dark',
            "dark": 'text-light',
            "info": 'text-dark',
            "light": 'text-dark',
            "primary": 'text-dark',
            "secondary": 'text-dark',
            "success": 'text-dark',
            "warning": 'text-dark',
        };
        this.onChange = () => { };
        this.onTouched = () => { };
    }
    get cssClass() {
        return this.cssColor[this.status];
    }
    get cssClassLabel() {
        return this.cssColorLabel[this.status];
    }
    get disabled() {
        return this.isDisabled;
    }
    set disabled(value) {
        if (this.disabled !== value) {
            this.isDisabled = !this.disabled;
            this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', this.disabled);
        }
    }
    get checked() {
        return this.isChecked;
    }
    set checked(value) {
        this.isChecked = value;
    }
    get enabled() {
        return !this.disabled;
    }
    ngOnInit() {
        this.status = this.vlLayoutService.validateStatus(this.status);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.isChecked = value;
        this.changeDetector.markForCheck();
    }
    setDisabledState(value) {
        this.disabled = value;
        this.changeDetector.markForCheck();
    }
    setTouched() {
        this.onTouched();
    }
    inputChange(event) {
        const input = event.target;
        this.isChecked = input.checked;
        this.checkedChange.emit(this.isChecked);
        this.onChange(this.isChecked);
    }
}
VlCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlCheckboxComponent, selector: "vl-checkbox", inputs: { status: "status", disabled: "disabled", checked: "checked" }, outputs: { checkedChange: "checkedChange" }, host: { properties: { "class": "this.class", "class.disabled": "this.disabled", "attr.enabled": "this.enabled" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlCheckboxComponent),
            multi: true,
        }], ngImport: i0, template: "<label class=\"group flex items-center py-1\">\n  <input type=\"checkbox\" class=\"hidden absolute h-px w-px overflow-hidden peer\" [disabled]=\"disabled\" [checked]=\"checked\" (change)=\"inputChange($event)\" (blur)=\"setTouched()\" (click)=\"$event.stopPropagation()\">\n  <div [ngClass]=\"cssClass\" class=\"absolute h-5 w-5 rounded border peer-disabled:opacity-25\">\n    <div class=\"absolute top-1/2 left-1/2 w-1/2 text-white\">\n      <ng-container *ngTemplateOutlet=\"svg\"></ng-container>\n    </div>\n  </div>\n\n  <span [ngClass]=\"cssClassLabel\" class=\"ml-5 pl-2 peer-disabled:opacity-25\">\n    <ng-content></ng-content>\n  </span>\n</label>\n\n<ng-template #svg>\n  <svg *ngIf=\"checked\" class=\"w-3.5 h-3.5 absolute translate-x-[-50%] translate-y-[-50%] text-white\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" zoomAndPan=\"magnify\" viewBox=\"0 0 30 30.000001\" preserveAspectRatio=\"xMidYMid meet\" version=\"1.0\">\n    <defs>\n      <clipPath id=\"id1\">\n        <path d=\"M 2.328125 4.222656 L 27.734375 4.222656 L 27.734375 24.542969 L 2.328125 24.542969 Z M 2.328125 4.222656 \" clip-rule=\"nonzero\" />\n      </clipPath>\n    </defs>\n    <g>\n      <path class=\"fill-white\" fill=\"rgb(13.729858%, 12.159729%, 12.548828%)\" d=\"M 27.5 7.53125 L 24.464844 4.542969 C 24.15625 4.238281 23.65625 4.238281 23.347656 4.542969 L 11.035156 16.667969 L 6.824219 12.523438 C 6.527344 12.230469 6 12.230469 5.703125 12.523438 L 2.640625 15.539062 C 2.332031 15.84375 2.332031 16.335938 2.640625 16.640625 L 10.445312 24.324219 C 10.59375 24.472656 10.796875 24.554688 11.007812 24.554688 C 11.214844 24.554688 11.417969 24.472656 11.566406 24.324219 L 27.5 8.632812 C 27.648438 8.488281 27.734375 8.289062 27.734375 8.082031 C 27.734375 7.875 27.648438 7.679688 27.5 7.53125 Z M 27.5 7.53125\" />\n    </g>\n  </svg>\n</ng-template>", styles: [":host{display:flex;align-items:center;position:relative}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-checkbox', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlCheckboxComponent),
                            multi: true,
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"group flex items-center py-1\">\n  <input type=\"checkbox\" class=\"hidden absolute h-px w-px overflow-hidden peer\" [disabled]=\"disabled\" [checked]=\"checked\" (change)=\"inputChange($event)\" (blur)=\"setTouched()\" (click)=\"$event.stopPropagation()\">\n  <div [ngClass]=\"cssClass\" class=\"absolute h-5 w-5 rounded border peer-disabled:opacity-25\">\n    <div class=\"absolute top-1/2 left-1/2 w-1/2 text-white\">\n      <ng-container *ngTemplateOutlet=\"svg\"></ng-container>\n    </div>\n  </div>\n\n  <span [ngClass]=\"cssClassLabel\" class=\"ml-5 pl-2 peer-disabled:opacity-25\">\n    <ng-content></ng-content>\n  </span>\n</label>\n\n<ng-template #svg>\n  <svg *ngIf=\"checked\" class=\"w-3.5 h-3.5 absolute translate-x-[-50%] translate-y-[-50%] text-white\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" zoomAndPan=\"magnify\" viewBox=\"0 0 30 30.000001\" preserveAspectRatio=\"xMidYMid meet\" version=\"1.0\">\n    <defs>\n      <clipPath id=\"id1\">\n        <path d=\"M 2.328125 4.222656 L 27.734375 4.222656 L 27.734375 24.542969 L 2.328125 24.542969 Z M 2.328125 4.222656 \" clip-rule=\"nonzero\" />\n      </clipPath>\n    </defs>\n    <g>\n      <path class=\"fill-white\" fill=\"rgb(13.729858%, 12.159729%, 12.548828%)\" d=\"M 27.5 7.53125 L 24.464844 4.542969 C 24.15625 4.238281 23.65625 4.238281 23.347656 4.542969 L 11.035156 16.667969 L 6.824219 12.523438 C 6.527344 12.230469 6 12.230469 5.703125 12.523438 L 2.640625 15.539062 C 2.332031 15.84375 2.332031 16.335938 2.640625 16.640625 L 10.445312 24.324219 C 10.59375 24.472656 10.796875 24.554688 11.007812 24.554688 C 11.214844 24.554688 11.417969 24.472656 11.566406 24.324219 L 27.5 8.632812 C 27.648438 8.488281 27.734375 8.289062 27.734375 8.082031 C 27.734375 7.875 27.648438 7.679688 27.5 7.53125 Z M 27.5 7.53125\" />\n    </g>\n  </svg>\n</ng-template>", styles: [":host{display:flex;align-items:center;position:relative}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: VlLayoutService }]; }, propDecorators: { checkedChange: [{
                type: Output
            }], status: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], checked: [{
                type: Input
            }], enabled: [{
                type: HostBinding,
                args: ['attr.enabled']
            }] } });

class VlCheckboxModule {
}
VlCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxModule, declarations: [VlCheckboxComponent], imports: [CommonModule], exports: [VlCheckboxComponent] });
VlCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        VlCheckboxComponent
                    ],
                    exports: [
                        VlCheckboxComponent
                    ]
                }]
        }] });

class VlPopoverRef {
    constructor(content, context, id) {
        this.content = content;
        this.context = context;
        this.id = id;
        this.closed$ = new Subject();
        this.opened$ = new Subject();
        this.destroyed$ = new Subject();
    }
    get onClose() {
        return this.closed$.asObservable();
    }
    get onOpen() {
        return this.opened$.asObservable();
    }
    get onDestroy() {
        return this.destroyed$.asObservable();
    }
    destroy() {
        // console.log(this.id, "popover.ref destroy");
        this.isOpen = false;
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    open() {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        this.opened$.next();
    }
    close() {
        if (!this.isOpen) {
            return;
        }
        this.isOpen = false;
        this.closed$.next();
    }
}

class VlPopoverComponent {
    constructor(el, popoverRef, injector) {
        this.el = el;
        this.popoverRef = popoverRef;
        this.mouseEnter$ = new Subject();
        this.mouseLeave$ = new Subject();
    }
    get mouseEnter() {
        return this.mouseEnter$.asObservable();
    }
    get mouseLeave() {
        return this.mouseLeave$.asObservable();
    }
    get height() {
        return this.el.nativeElement.offsetHeight;
    }
    //@HostListener('focusin')
    showOnHover(event) {
        event.stopPropagation();
        this.mouseEnter$.next();
    }
    //@HostListener('focusout')
    hideOnHover(event) {
        event.stopPropagation();
        this.mouseLeave$.next();
    }
    ngOnInit() {
        this.content = this.popoverRef.content;
        if (this.content instanceof TemplateRef) {
            this.context = { $implicit: this.popoverRef.context, ref: this.popoverRef };
            this.renderMethod = 'template';
        }
        else if (this.content instanceof Type) {
            this.injector = Injector.create({
                providers: [
                    { provide: VL_POPOVER_CONTEXT, useValue: this.popoverRef.context },
                ]
            });
            this.context = this.popoverRef.context;
            this.renderMethod = 'component';
        }
    }
    ngOnDestroy() {
    }
}
VlPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverComponent, deps: [{ token: i0.ElementRef }, { token: VlPopoverRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
VlPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlPopoverComponent, selector: "vl-popover", host: { listeners: { "mouseenter": "showOnHover($event)", "pointerleave": "hideOnHover($event)" } }, ngImport: i0, template: "<div [@animation] [ngSwitch]=\"renderMethod\">\n    <ng-container *ngSwitchCase=\"'template'\">\n        <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'component'\">\n        <ng-container *ngComponentOutlet=\"content; injector: injector; context: context\"></ng-container>\n    </ng-container>\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], animations: [
        trigger('animation', [
            transition(':enter', [
                style({
                    opacity: 0,
                    transform: 'scale(0.8)'
                }),
                animate('0.15s ease-in-out', style({
                    opacity: 1,
                    transform: 'scale(1)'
                }))
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    transform: 'scale(1)'
                }),
                animate('0.15s ease-in-out', style({
                    opacity: 0,
                    transform: 'scale(0.8)'
                }))
            ])
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-popover', animations: [
                        trigger('animation', [
                            transition(':enter', [
                                style({
                                    opacity: 0,
                                    transform: 'scale(0.8)'
                                }),
                                animate('0.15s ease-in-out', style({
                                    opacity: 1,
                                    transform: 'scale(1)'
                                }))
                            ]),
                            transition(':leave', [
                                style({
                                    opacity: 1,
                                    transform: 'scale(1)'
                                }),
                                animate('0.15s ease-in-out', style({
                                    opacity: 0,
                                    transform: 'scale(0.8)'
                                }))
                            ])
                        ])
                    ], template: "<div [@animation] [ngSwitch]=\"renderMethod\">\n    <ng-container *ngSwitchCase=\"'template'\">\n        <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"'component'\">\n        <ng-container *ngComponentOutlet=\"content; injector: injector; context: context\"></ng-container>\n    </ng-container>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: VlPopoverRef }, { type: i0.Injector }]; }, propDecorators: { showOnHover: [{
                type: HostListener,
                args: ['mouseenter', ['$event']]
            }], hideOnHover: [{
                type: HostListener,
                args: ['pointerleave', ['$event']]
            }] } });

const VL_POPOVER_CONTEXT = new InjectionToken('Vl Popover Context');
class VlPopoverService {
    constructor(overlay) {
        this.overlay = overlay;
        this.overlayPositions = {
            'top': {
                overlayX: 'center',
                overlayY: 'bottom',
                originX: 'center',
                originY: 'top',
                offsetY: -3
            },
            'bottom': {
                overlayX: 'center',
                overlayY: 'top',
                originX: 'center',
                originY: 'bottom',
                offsetY: 3
            },
            'left': {
                originX: 'start',
                originY: 'center',
                overlayX: 'end',
                overlayY: 'center',
                offsetX: -3,
            },
            'right': {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'center',
                offsetX: 3,
            }
        };
        this.unsubscribe$ = new Subject();
    }
    setupMousePositionListener() {
        document.addEventListener('mousemove', (event) => this.onMouseMove(event));
    }
    onMouseMove(event) {
        this.mousePositionSubject.next({ x: event.clientX, y: event.clientY });
    }
    setupMousePositionSubscription(popoverRef) {
        this.mousePositionSubject
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((position) => {
            const popoverHeight = popoverRef.componentRef.instance.height;
            const offsetY = popoverHeight / 2;
            const positionStrategy = this.overlay.position()
                .global()
                .left(position.x + 50 + "px")
                .top(position.y - offsetY + "px");
            popoverRef.overlayRef.updatePositionStrategy(positionStrategy);
            popoverRef.overlayRef.updatePosition();
        });
    }
    create(elementRef, config) {
        this.id = config.id;
        if (config.content == null) {
            return null;
        }
        const popoverRef = new VlPopoverRef(config.content, config.context, config.id);
        let positionStategies = [];
        if (this.overlayPositions[config.position]) {
            positionStategies.push(this.overlayPositions[config.position]);
        }
        const filterPositions = Object.keys(this.overlayPositions).filter((key) => key != config.position);
        const filterPositionStrategies = filterPositions.map((key) => {
            return this.overlayPositions[key];
        });
        positionStategies = positionStategies.concat(filterPositionStrategies);
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(elementRef)
            .withPositions(positionStategies)
            .withLockedPosition(true)
            .withPush(false)
            .withFlexibleDimensions(false);
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        popoverRef.overlayRef = this.overlay.create({
            positionStrategy: positionStrategy,
            scrollStrategy: scrollStrategy
        });
        this.subscriptions(popoverRef, config);
        if (config.position === 'mouse') {
            this.mousePositionSubject = new Subject();
            this.setupMousePositionListener();
            this.setupMousePositionSubscription(popoverRef);
        }
        return popoverRef;
    }
    subscriptions(popoverRef, config) {
        /*popoverRef.overlayRef
            .detachments() // Scroll detection
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                popoverRef.close();
            });*/
        if (config.closeOnClick) {
            popoverRef.overlayRef
                .outsidePointerEvents()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => {
                popoverRef.close();
            });
        }
        popoverRef.onOpen
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            this.open(popoverRef);
        });
        popoverRef.onClose
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            //console.log(this.id, "popover.service onClose subscribe");
            this.close(popoverRef);
        });
        popoverRef.onDestroy
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            //console.log(this.id, "popover.service onDestroy subscribe");
            this.destroy(popoverRef);
        });
    }
    open(popoverRef) {
        if (!popoverRef || popoverRef.overlayRef?.hasAttached()) {
            return;
        }
        //const context = popoverRef.content instanceof TemplateRef ? { $implicit: popoverRef.context, popoverRef } : popoverRef.context;
        const injector = Injector.create({
            providers: [
                { provide: VL_POPOVER_CONTEXT, useValue: popoverRef.context },
                { provide: VlPopoverRef, useValue: popoverRef }
            ]
        });
        const portal = new ComponentPortal(VlPopoverComponent, null, injector);
        popoverRef.componentRef = popoverRef.overlayRef.attach(portal);
    }
    close(popoverRef) {
        if (popoverRef?.overlayRef?.hasAttached()) {
            popoverRef.overlayRef.detach();
        }
    }
    destroy(popoverRef) {
        document.removeEventListener('mousemove', (event) => this.onMouseMove(event));
        this.mousePositionSubject?.complete();
        popoverRef.overlayRef.dispose();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        //console.log(this.id, "popover.service destroy");
    }
}
VlPopoverService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverService, deps: [{ token: i1.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
VlPopoverService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Overlay }]; } });

class VlListItemComponent {
    tailwindClass() {
        return true;
    }
}
VlListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlListItemComponent, selector: "vl-list-item", host: { properties: { "class": "this.class", "class.py-3": "this.tailwindClass", "class.border-b": "this.tailwindClass", "class.border-light-500": "this.tailwindClass", "class.items-center": "this.tailwindClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-list-item',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], tailwindClass: [{
                type: HostBinding,
                args: ['class.py-3']
            }, {
                type: HostBinding,
                args: ['class.border-b']
            }, {
                type: HostBinding,
                args: ['class.border-light-500']
            }, {
                type: HostBinding,
                args: ['class.items-center']
            }] } });
class VlListComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlListComponent, selector: "vl-list", ngImport: i0, template: "<ng-content select=\"vl-list-item\"></ng-content>", styles: [":host{display:flex;flex-direction:column}:host ::ng-deep vl-list-item{align-items:center}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-list', template: "<ng-content select=\"vl-list-item\"></ng-content>", styles: [":host{display:flex;flex-direction:column}:host ::ng-deep vl-list-item{align-items:center}\n"] }]
        }], ctorParameters: function () { return []; } });

class VlContextMenuComponent {
    constructor(popoverContext) {
        this.popoverContext = popoverContext;
    }
    ngOnInit() {
        this.contextMenu = this.popoverContext.contextMenu;
    }
    onClick(contextMenuItem) {
        this.popoverContext.contextMenuItemClicked?.emit(contextMenuItem);
    }
}
VlContextMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuComponent, deps: [{ token: VL_POPOVER_CONTEXT }], target: i0.ɵɵFactoryTarget.Component });
VlContextMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlContextMenuComponent, selector: "vl-context-menu", ngImport: i0, template: "<vl-card>\n  <vl-card-body class=\"!p-0 !overlow-auto text-center\">\n    <vl-list class=\"min-w-[150px]\">\n      <vl-list-item *ngFor=\"let item of contextMenu\" class=\"!p-2 cursor-pointer\" (click)=\"onClick(item)\">{{ item.title }}</vl-list-item>\n    </vl-list>\n  </vl-card-body>\n</vl-card>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: VlCardComponent, selector: "vl-card" }, { kind: "component", type: VlCardBodyComponent, selector: "vl-card-body" }, { kind: "component", type: VlListComponent, selector: "vl-list" }, { kind: "component", type: VlListItemComponent, selector: "vl-list-item" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-context-menu', template: "<vl-card>\n  <vl-card-body class=\"!p-0 !overlow-auto text-center\">\n    <vl-list class=\"min-w-[150px]\">\n      <vl-list-item *ngFor=\"let item of contextMenu\" class=\"!p-2 cursor-pointer\" (click)=\"onClick(item)\">{{ item.title }}</vl-list-item>\n    </vl-list>\n  </vl-card-body>\n</vl-card>" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [VL_POPOVER_CONTEXT]
                }] }]; } });

class VlContextMenuDirective {
    constructor(popoverService, elementRef) {
        this.popoverService = popoverService;
        this.elementRef = elementRef;
        this.vlContextMenu = null;
        this.vlContextMenuClicked = new EventEmitter();
        this.destroy$ = new Subject();
    }
    click() {
        if (this.isOpened) {
            return;
        }
        this.popoverRef = this.popoverService.create(this.elementRef, this.popoverConfig);
        this.popoverRef.open();
        this.isOpened = true;
        this.popoverRef.onClose
            .pipe(take(1))
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.isOpened = false;
        });
    }
    ngOnInit() {
        const context = {
            contextMenu: this.vlContextMenu,
            contextMenuItemClicked: this.vlContextMenuClicked
        };
        this.popoverConfig = {
            content: VlContextMenuComponent,
            context: context,
            closeOnClick: true,
            position: 'bottom'
        };
        this.elementRef.nativeElement.classList.add("cursor-pointer");
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.popoverRef?.close();
        this.popoverRef?.destroy();
    }
}
VlContextMenuDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuDirective, deps: [{ token: VlPopoverService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
VlContextMenuDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: VlContextMenuDirective, selector: "[vlContextMenu]", inputs: { vlContextMenu: "vlContextMenu" }, outputs: { vlContextMenuClicked: "vlContextMenuClicked" }, host: { listeners: { "click": "click()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[vlContextMenu]'
                }]
        }], ctorParameters: function () { return [{ type: VlPopoverService }, { type: i0.ElementRef }]; }, propDecorators: { vlContextMenu: [{
                type: Input
            }], vlContextMenuClicked: [{
                type: Output
            }], click: [{
                type: HostListener,
                args: ['click']
            }] } });

class VlListModule {
}
VlListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlListModule, declarations: [VlListComponent,
        VlListItemComponent], imports: [CommonModule], exports: [VlListComponent,
        VlListItemComponent] });
VlListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlListComponent,
                        VlListItemComponent
                    ],
                    exports: [
                        VlListComponent,
                        VlListItemComponent
                    ]
                }]
        }] });

class VlContextMenuModule {
}
VlContextMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlContextMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuModule, declarations: [VlContextMenuComponent,
        VlContextMenuDirective], imports: [CommonModule,
        VlCardModule,
        VlListModule], exports: [VlContextMenuDirective] });
VlContextMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuModule, imports: [CommonModule,
        VlCardModule,
        VlListModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlContextMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlCardModule,
                        VlListModule
                    ],
                    declarations: [
                        VlContextMenuComponent,
                        VlContextMenuDirective
                    ],
                    exports: [
                        VlContextMenuDirective
                    ]
                }]
        }] });

class ContextMenuService {
    constructor() { }
}
ContextMenuService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ContextMenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ContextMenuService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ContextMenuService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ContextMenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class VlIconLibraryService {
    constructor() {
        this.packs = new Map();
    }
    registerPack(name, pack) {
        this.packs.set(name, {
            packClass: pack.packClass,
            iconPrefix: pack.iconPrefix,
            type: "font"
        });
    }
    registerSvgPack(name, icons) {
        this.packs.set(name, {
            icons: icons,
            type: "svg"
        });
    }
    registerSvgAssetPack(name, icons) {
        this.packs.set(name, {
            icons: icons,
            type: "svg-asset"
        });
    }
    getPack(name) {
        return this.packs.get(name);
    }
}
VlIconLibraryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconLibraryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
VlIconLibraryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconLibraryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconLibraryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class VlIconComponent {
    constructor(iconLibraryService, layoutService, sanitizer) {
        this.iconLibraryService = iconLibraryService;
        this.layoutService = layoutService;
        this.sanitizer = sanitizer;
        this.size = "base";
        this.status = "primary";
        this.widthSize = {
            "xs": 'w-[12px]',
            "sm": 'w-[14px]',
            "base": 'w-[16px]',
            "lg": 'w-[18px]',
            "xl": 'w-[20px]',
            "2xl": 'w-[24px]',
            "3xl": 'w-[30px]',
            "4xl": 'w-[36px]',
            "5xl": 'w-[48px]',
            "6xl": 'w-[60px]',
            "7xl": 'w-[72px]',
            "8xl": 'w-[96px]',
            "9xl": 'w-[128px]'
        };
        this.heightSize = {
            "xs": 'h-[12px]',
            "sm": 'h-[14px]',
            "base": 'h-[16px]',
            "lg": 'h-[18px]',
            "xl": 'h-[20px]',
            "2xl": 'h-[24px]',
            "3xl": 'h-[30px]',
            "4xl": 'h-[36px]',
            "5xl": 'h-[48px]',
            "6xl": 'h-[60px]',
            "7xl": 'h-[72px]',
            "8xl": 'h-[96px]',
            "9xl": 'h-[128px]'
        };
    }
    get fontClass() {
        const iconPackClass = this.iconPack ? `${this.iconPack?.packClass} ${this.iconPack?.iconPrefix}-${this.icon}` : '';
        return `${TEXT_COLOR[this.status]} ${TEXT_SIZE[this.size]} ${iconPackClass}`;
    }
    get svgClass() {
        return `${this.widthSize[this.size]} ${this.heightSize[this.size]} ${FILL_COLOR[this.status]} ${TEXT_SIZE[this.size]}`;
    }
    ngOnInit() {
        this.iconPack = this.iconLibraryService.getPack(this.pack);
        this.renderIcon();
    }
    ngOnChange() {
        this.renderIcon();
    }
    renderIcon() {
        this.type = this.iconPack.type;
        this.size = this.layoutService.validateTextSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
        const icon = this.iconPack?.icons?.[this.icon];
        if (this.type == 'svg') {
            this.metaData = this.sanitizer.bypassSecurityTrustHtml(icon);
        }
        else if (this.type == 'svg-asset') {
            this.metaData = './assets/' + icon;
        }
    }
}
VlIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconComponent, deps: [{ token: VlIconLibraryService }, { token: VlLayoutService }, { token: i3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
VlIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlIconComponent, selector: "vl-icon", inputs: { pack: "pack", icon: "icon", size: "size", status: "status" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<ng-content></ng-content>\n\n<ng-container [ngSwitch]=\"type\">\n    <i *ngSwitchCase=\"'font'\" [ngClass]=\"fontClass\" class=\"flex items-center\"></i>\n    <div *ngSwitchCase=\"'svg'\" [innerHtml]=\"metaData\" [ngClass]=\"svgClass\" class=\"flex items-center\"></div>\n    <img *ngSwitchCase=\"'svg-asset'\" [src]=\"metaData\" [ngClass]=\"svgClass\" class=\"flex items-center\">\n</ng-container>", styles: [":host{position:relative;display:flex;align-items:center}:host svg{height:100%}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n\n<ng-container [ngSwitch]=\"type\">\n    <i *ngSwitchCase=\"'font'\" [ngClass]=\"fontClass\" class=\"flex items-center\"></i>\n    <div *ngSwitchCase=\"'svg'\" [innerHtml]=\"metaData\" [ngClass]=\"svgClass\" class=\"flex items-center\"></div>\n    <img *ngSwitchCase=\"'svg-asset'\" [src]=\"metaData\" [ngClass]=\"svgClass\" class=\"flex items-center\">\n</ng-container>", styles: [":host{position:relative;display:flex;align-items:center}:host svg{height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: VlIconLibraryService }, { type: VlLayoutService }, { type: i3.DomSanitizer }]; }, propDecorators: { pack: [{
                type: Input
            }], icon: [{
                type: Input
            }], size: [{
                type: Input
            }], status: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlIconModule {
}
VlIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlIconModule, declarations: [VlIconComponent], imports: [CommonModule], exports: [VlIconComponent] });
VlIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlIconComponent
                    ],
                    exports: [
                        VlIconComponent
                    ]
                }]
        }] });

class VlInputComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.status = "primary";
        this.size = "base";
        this.placeholder = "";
        this.type = "text";
        this.keyup = new EventEmitter();
        this.blur = new EventEmitter();
        this.cssColor = {
            "danger": 'hover:border-danger bg-light/50 text-dark',
            "dark": 'hover:border-dark bg-dark/50 text-light',
            "info": 'hover:border-info bg-light/50 text-dark ',
            "light": 'hover:border-light bg-light/50 text-dark',
            "primary": 'hover:border-primary bg-light/50 text-dark',
            "secondary": 'hover:border-econdary bg-light/50 text-dark',
            "success": 'hover:border-success bg-light/50 text-dark',
            "warning": 'hover:border-warning bg-light/50 text-dark'
        };
        this.cssSize = {
            xs: `${PADDING_SIZE['base']} text-[.625rem]`,
            sm: `${PADDING_SIZE['lg']} text-xs`,
            base: `${PADDING_SIZE['xl']} text-sm`,
            lg: `${PADDING_SIZE['xl']} text-base`,
            xl: `${PADDING_SIZE['xl']} text-lg`,
        };
        this.innerValue = '';
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    get wrapperClass() {
        return `${this.cssColor[this.status]} ${this.cssSize[this.size]}`;
    }
    get inputClass() {
        return this.cssSize[this.size];
    }
    get elementRef() {
        return this.input;
    }
    get inputValue() {
        return this.innerValue;
    }
    ;
    set inputValue(v) {
        if (v !== this.innerValue) {
            let value = null;
            switch (this.type) {
                case 'string':
                    value = String(v);
                    break;
                case 'number':
                    value = Number(v);
                    break;
                case 'date':
                    value = new Date(v);
                    break;
                default:
                    value = v;
            }
            this.innerValue = value;
            this.onChangeCallback(value);
        }
    }
    ngOnInit() {
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
    }
    onBlur() {
        this.onTouchedCallback();
        this.blur.emit();
    }
    writeValue(value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    ngAfterViewInit() {
        this.input.nativeElement.value = this.value;
    }
    onKeyUp(value) {
        if (this.disabled) {
            return;
        }
        this.keyup.emit(value);
    }
}
VlInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlInputComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlInputComponent, selector: "vl-input", inputs: { status: "status", size: "size", placeholder: "placeholder", value: "value", disabled: "disabled", type: "type", min: "min", max: "max" }, outputs: { keyup: "keyup", blur: "blur" }, host: { properties: { "class": "this.class" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlInputComponent),
            multi: true
        }], viewQueries: [{ propertyName: "input", first: true, predicate: ["inputRef"], descendants: true }], ngImport: i0, template: "<div class=\"relative flex w-full border disabled:opacity-25 rounded items-center duration-300 transition\" [ngClass]=\"wrapperClass\">\n    <ng-content select=\"vl-icon\"></ng-content>\n    <input #inputRef *ngIf=\"value\" class=\"w-full outline-none bg-transparent\" [disabled]=\"disabled\" [value]=\"value\" (blur)=\"onBlur()\" [min]=\"min\" [max]=\"max\" [type]=\"type\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\">\n    <input #inputRef *ngIf=\"!value\" [(ngModel)]=\"inputValue\" class=\"w-full outline-none bg-transparent\" [disabled]=\"disabled\" (blur)=\"onBlur()\" [min]=\"min\" [max]=\"max\" [type]=\"type\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\">\n</div>", styles: [":host{display:block}:host ::ng-deep vl-icon{display:flex;align-self:center;padding-right:8px}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-input', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlInputComponent),
                            multi: true
                        }], template: "<div class=\"relative flex w-full border disabled:opacity-25 rounded items-center duration-300 transition\" [ngClass]=\"wrapperClass\">\n    <ng-content select=\"vl-icon\"></ng-content>\n    <input #inputRef *ngIf=\"value\" class=\"w-full outline-none bg-transparent\" [disabled]=\"disabled\" [value]=\"value\" (blur)=\"onBlur()\" [min]=\"min\" [max]=\"max\" [type]=\"type\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\">\n    <input #inputRef *ngIf=\"!value\" [(ngModel)]=\"inputValue\" class=\"w-full outline-none bg-transparent\" [disabled]=\"disabled\" (blur)=\"onBlur()\" [min]=\"min\" [max]=\"max\" [type]=\"type\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\">\n</div>", styles: [":host{display:block}:host ::ng-deep vl-icon{display:flex;align-self:center;padding-right:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { input: [{
                type: ViewChild,
                args: ['inputRef']
            }], status: [{
                type: Input
            }], size: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], type: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], keyup: [{
                type: Output
            }], blur: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const COMPONENTS$6 = [
    VlInputComponent
];
class VlInputModule {
}
VlInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlInputModule, declarations: [VlInputComponent], imports: [CommonModule,
        FormsModule], exports: [VlInputComponent] });
VlInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlInputModule, imports: [CommonModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    declarations: [
                        ...COMPONENTS$6
                    ],
                    exports: [
                        ...COMPONENTS$6
                    ]
                }]
        }] });

class VlPopoverDirective {
    constructor(vlPopoverService, elementRef) {
        this.vlPopoverService = vlPopoverService;
        this.elementRef = elementRef;
        this.vlPopoverCloseOnClick = true;
        this.vlPopoverPosition = 'bottom';
        this.vlPopoverTrigger = "click";
        this.vlPopoverStateChange = new EventEmitter();
        this.destroy$ = new Subject();
        this.cancelClosing$ = new Subject();
    }
    ngOnInit() {
        this.config = {
            position: this.vlPopoverPosition,
            content: this.vlPopover,
            context: this.vlPopoverContext,
            closeOnClick: this.vlPopoverCloseOnClick || this.vlPopoverTrigger == 'click',
            id: this.vlPopoverId
        };
    }
    ngOnDestroy() {
        this.cancelClosing$.complete();
        this.destroy$.next();
        this.destroy$.complete();
        this.popoverRef?.destroy();
    }
    // Click oppening
    click() {
        if (this.vlPopoverTrigger != 'click') {
            return;
        }
        this.open();
    }
    // Hover oppening
    showOnHover() {
        if (this.vlPopoverTrigger != 'hover') {
            return;
        }
        this.open();
    }
    // Hover closing
    hideOnHover() {
        if (this.vlPopoverTrigger != 'hover') {
            return;
        }
        this.close();
    }
    close() {
        if (!this.popoverRef?.isOpen) {
            return;
        }
        //console.log(this.vlPopoverId, "popover.directive close");
        //this.cancelClosing$.next(); // Cancel previous closing
        timer(33)
            .pipe(takeUntil(this.cancelClosing$))
            //.pipe(take(1))
            .subscribe(() => {
            this.popoverRef.close();
            this.vlPopoverStateChange?.emit(false);
            // this.popoverRef?.destroy();
            // this.popoverRef = null;
            this.destroy$.next();
            //this.destroy$.complete();
            //  this.cancelClosing$.complete();
            // console.log(this.vlPopoverId, "popover.directive closed");
        });
    }
    open() {
        //console.log(this.vlPopoverId, "popover.directive open");
        if (!this.popoverRef) {
            this.popoverRef = this.vlPopoverService.create(this.elementRef, this.config);
            //  this.cancelClosing$ = new Subject();
        }
        // this.cancelClosing$.next(); // Cancel closing
        if (!this.popoverRef.isOpen) {
            this.popoverRef.open();
            this.vlPopoverStateChange?.emit(true);
        }
        if (this.vlPopoverTrigger != 'hover') {
        }
        this.popoverRef.componentRef?.instance?.mouseEnter
            .pipe(first())
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            //  console.log(this.vlPopoverId, "popover.directive mouseEnter subscribe")
            this.cancelClosing$.next();
        });
        this.popoverRef.componentRef?.instance?.mouseLeave
            .pipe(first())
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            // console.log(this.vlPopoverId, "popover.directive mouseleave subscribe")
            this.close();
        });
    }
}
VlPopoverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverDirective, deps: [{ token: VlPopoverService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
VlPopoverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: VlPopoverDirective, selector: "[vlPopover]", inputs: { vlPopover: "vlPopover", vlPopoverCloseOnClick: "vlPopoverCloseOnClick", vlPopoverContext: "vlPopoverContext", vlPopoverPosition: "vlPopoverPosition", vlPopoverTrigger: "vlPopoverTrigger", vlPopoverId: "vlPopoverId" }, outputs: { vlPopoverStateChange: "vlPopoverStateChange" }, host: { listeners: { "click": "click()", "focusin": "showOnHover()", "mouseenter": "showOnHover()", "focusout": "hideOnHover()", "mouseleave": "hideOnHover()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[vlPopover]' }]
        }], ctorParameters: function () { return [{ type: VlPopoverService }, { type: i0.ElementRef }]; }, propDecorators: { vlPopover: [{
                type: Input
            }], vlPopoverCloseOnClick: [{
                type: Input
            }], vlPopoverContext: [{
                type: Input
            }], vlPopoverPosition: [{
                type: Input
            }], vlPopoverTrigger: [{
                type: Input
            }], vlPopoverId: [{
                type: Input
            }], vlPopoverStateChange: [{
                type: Output
            }], click: [{
                type: HostListener,
                args: ['click']
            }], showOnHover: [{
                type: HostListener,
                args: ['focusin']
            }, {
                type: HostListener,
                args: ['mouseenter']
            }], hideOnHover: [{
                type: HostListener,
                args: ['focusout']
            }, {
                type: HostListener,
                args: ['mouseleave']
            }] } });

class VlPopoverModule {
}
VlPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverModule, declarations: [VlPopoverComponent,
        VlPopoverDirective], imports: [CommonModule,
        OverlayModule], exports: [VlPopoverDirective] });
VlPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverModule, providers: [
        Overlay
    ], imports: [CommonModule,
        OverlayModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        OverlayModule
                    ],
                    declarations: [
                        VlPopoverComponent,
                        VlPopoverDirective
                    ],
                    exports: [
                        VlPopoverDirective
                    ],
                    providers: [
                        Overlay
                    ]
                }]
        }] });

class VlProgressBarComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.status = "primary";
        this.value = 0;
        this.label = 0;
        this.size = "base";
        this.displayLabel = false;
        this.cssColorProgress = {
            "danger": 'bg-danger text-white',
            "dark": 'bg-dark text-white',
            "info": 'bg-info text-white',
            "light": 'bg-light text-dark',
            "primary": 'bg-primary text-white',
            "secondary": 'bg-secondary text-white',
            "success": 'bg-success text-white',
            "warning": 'bg-warning text-white',
        };
        this.cssColorContainer = {
            "danger": 'bg-gray-200',
            "dark": 'bg-gray-200',
            "info": 'bg-gray-200',
            "light": 'bg-gray-200',
            "primary": 'bg-gray-200',
            "secondary": 'bg-gray-200',
            "success": 'bg-gray-200',
            "warning": 'bg-gray-200',
        };
        this.cssSize = {
            "xs": "h-2",
            "sm": "h-3",
            "base": "h-4",
            "lg": "h-5",
            "xl": "h-6"
        };
    }
    get cssClassProgress() {
        return `${this.cssColorProgress[this.status]} ${this.cssSize[this.size]}`;
    }
    get cssClassContainer() {
        return `${this.cssColorContainer[this.status]} ${this.cssSize[this.size]}`;
    }
    ngOnInit() {
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
        this.displayLabel = this.size != 'xs';
        if (!this.displayLabel) {
            return;
        }
    }
}
VlProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlProgressBarComponent, selector: "vl-progress-bar", inputs: { status: "status", value: "value", label: "label", size: "size" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div class=\"flex w-full rounded-full overflow-hidden\" [ngClass]=\"cssClassContainer\">\n  <div [ngClass]=\"cssClassProgress\" class=\"transition-[width] ease-out duration-1000 flex flex-col justify-center overflow-hidden bg-blue-500 text-xs text-center truncate\" [style.width.%]=\"value\">\n    <ng-container *ngIf=\"displayLabel && label\"> {{ label }}</ng-container>\n  </div>\n</div>", styles: [":host{display:block}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-progress-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"flex w-full rounded-full overflow-hidden\" [ngClass]=\"cssClassContainer\">\n  <div [ngClass]=\"cssClassProgress\" class=\"transition-[width] ease-out duration-1000 flex flex-col justify-center overflow-hidden bg-blue-500 text-xs text-center truncate\" [style.width.%]=\"value\">\n    <ng-container *ngIf=\"displayLabel && label\"> {{ label }}</ng-container>\n  </div>\n</div>", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { status: [{
                type: Input
            }], value: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlProgressBarModule {
}
VlProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarModule, declarations: [VlProgressBarComponent], imports: [CommonModule], exports: [VlProgressBarComponent] });
VlProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlProgressBarComponent
                    ],
                    exports: [
                        VlProgressBarComponent
                    ]
                }]
        }] });

class VlRadioComponent {
    constructor(cdr, layoutService) {
        this.cdr = cdr;
        this.layoutService = layoutService;
        this.status = "primary";
        this.valueChange = new EventEmitter();
        this.blur = new EventEmitter();
        this.cssColorOuter = {
            'danger': 'peer-disabled:peer-hover:bg-danger/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-danger/50 border-danger-500 bg-danger/25',
            "dark": 'peer-disabled:peer-hover:bg-dark/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-dark/50 border-dark-500 bg-dark/25',
            "info": 'peer-disabled:peer-hover:bg-info/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-info/50 border-info-500 bg-info/25',
            "light": 'peer-disabled:peer-hover:bg-light/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-light/50 border-light-500 bg-light/25',
            "primary": 'peer-disabled:peer-hover:bg-primary/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-primary/50 border-primary-500 bg-primary/25',
            "secondary": 'peer-disabled:peer-hover:bg-secondary/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-secondary/50 secondary-danger-500 bg-secondary/25',
            "success": 'peer-disabled:peer-hover:bg-success/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-success/50 border-success-500 bg-success/25',
            "warning": 'peer-disabled:peer-hover:bg-warning/25 peer-disabled:peer-checked:peer-hover:bg-white peer-hover:bg-warning/50 border-warning-500 bg-warning/25',
        };
        this.cssColorInner = {
            'danger': 'peer-checked:peer-hover:bg-danger peer-checked:bg-danger',
            "dark": 'peer-checked:peer-hover:bg-dark peer-checked:bg-dark',
            "info": 'peer-checked:peer-hover:bg-info peer-checked:bg-info',
            "light": 'peer-checked:peer-hover:bg-light peer-checked:bg-light',
            "primary": 'peer-checked:peer-hover:bg-primary peer-checked:bg-primary',
            "secondary": 'peer-checked:peer-hover:bg-secondary peer-checked:bg-secondary',
            "success": 'peer-checked:peer-hover:bg-success peer-checked:bg-success',
            "warning": 'peer-checked:peer-hover:bg-warning peer-checked:bg-warning',
        };
        this.cssColorLabel = {
            'danger': 'text-dark',
            "dark": 'text-light',
            "info": 'text-dark',
            "light": 'text-dark',
            "primary": 'text-dark',
            "secondary": 'text-dark',
            "success": 'text-dark',
            "warning": 'text-dark',
        };
    }
    get cssClassLabel() {
        return this.cssColorLabel[this.status];
    }
    get cssClassInner() {
        return this.cssColorInner[this.status];
    }
    get cssClassOuter() {
        return this.cssColorOuter[this.status];
    }
    ngOnInit() {
        this.status = this.layoutService.validateStatus(this.status);
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
    onChange(event) {
        event.stopPropagation();
        this.checked = true;
        this.valueChange.emit(this.value);
    }
    onClick(event) {
        event.stopPropagation();
    }
}
VlRadioComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlRadioComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlRadioComponent, selector: "vl-radio", inputs: { status: "status", disabled: "disabled", checked: "checked", name: "name", value: "value" }, outputs: { valueChange: "valueChange", blur: "blur" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<label class=\"group flex items-center relative\">\n  <input #input type=\"radio\" class=\"hidden absolute h-px w-px overflow-hidden peer\" [name]=\"name\" [value]=\"value\" [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" (click)=\"onClick($event)\">\n  <span [ngClass]=\"cssClassOuter\" class=\"absolute rounded-[50%] h-5 w-5 border peer-disabled:opacity-25 peer-checked:peer-hover:bg-white peer-checked:bg-white\"></span>\n  <span [ngClass]=\"cssClassInner\" class=\"absolute rounded-[50%] h-5 w-5 scale-[.6] peer-disabled:opacity-25\"></span>\n  <span [ngClass]=\"cssClassLabel\" class=\"ml-5 pl-1.5 peer-disabled:opacity-25\">\n    <ng-content></ng-content>\n  </span>\n</label>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"group flex items-center relative\">\n  <input #input type=\"radio\" class=\"hidden absolute h-px w-px overflow-hidden peer\" [name]=\"name\" [value]=\"value\" [checked]=\"checked\" [disabled]=\"disabled\" (change)=\"onChange($event)\" (click)=\"onClick($event)\">\n  <span [ngClass]=\"cssClassOuter\" class=\"absolute rounded-[50%] h-5 w-5 border peer-disabled:opacity-25 peer-checked:peer-hover:bg-white peer-checked:bg-white\"></span>\n  <span [ngClass]=\"cssClassInner\" class=\"absolute rounded-[50%] h-5 w-5 scale-[.6] peer-disabled:opacity-25\"></span>\n  <span [ngClass]=\"cssClassLabel\" class=\"ml-5 pl-1.5 peer-disabled:opacity-25\">\n    <ng-content></ng-content>\n  </span>\n</label>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: VlLayoutService }]; }, propDecorators: { status: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checked: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], blur: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlRadioGroupComponent {
    constructor(elementRef, document, layoutService) {
        this.elementRef = elementRef;
        this.document = document;
        this.layoutService = layoutService;
        this.valueChange = new EventEmitter();
        this.destroy$ = new Subject();
        this.onChange = (value) => { };
        this.onTouched = () => { };
    }
    get value() {
        return this.innerValue;
    }
    set value(value) {
        this.innerValue = value;
        this.updateRadio((radio) => radio.checked = radio.value == this.value, true);
    }
    ngOnInit() {
        this.status = this.layoutService.validateStatus(this.status);
    }
    ngOnChanges(changes) {
        if (changes['status']) {
            this.updateRadio((radio) => radio.status = changes['status'].currentValue, true);
        }
        if (changes['disabled']) {
            this.updateRadio((radio) => radio.disabled = changes['disabled'].currentValue, true);
        }
    }
    ngAfterContentInit() {
        this.updateRadio((radio) => radio.name = this.name);
        this.radios.changes
            .pipe(startWith(this.radios), switchMap((radios) => from(Promise.resolve(radios))), takeUntil(this.destroy$)).subscribe(() => this.updateAndSubscribeToRadios());
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.value = value;
    }
    setDisabledState(value) {
        this.disabled = value;
    }
    updateAndSubscribeToRadios() {
        this.updateValueFromCheckedOption();
        this.updateRadio((radio) => radio.name = this.name);
        this.updateRadio((radio) => {
            radio.checked = radio.value == this.value;
        }, true);
        if (typeof this.disabled !== 'undefined') {
            this.updateRadio((radio) => radio.disabled = this.disabled, true);
        }
        this.updateRadio((radio) => radio.status = this.status, true);
        this.subscribeOnRadiosValueChange();
        this.subscribeOnRadiosBlur();
    }
    updateRadio(updateFn, markForCheck = false) {
        if (!this.radios) {
            return;
        }
        for (let radio of this.radios) {
            updateFn(radio);
            if (markForCheck) {
                radio.markForCheck();
            }
        }
    }
    subscribeOnRadiosValueChange() {
        if (!this.radios?.length) {
            return;
        }
        merge(...this.radios.map((radio) => radio.valueChange))
            .pipe(takeUntil(merge(this.radios.changes, this.destroy$))).subscribe((value) => {
            this.writeValue(value);
            this.propagateValue(value);
        });
    }
    propagateValue(value) {
        this.valueChange.emit(value);
        this.onChange(value);
    }
    subscribeOnRadiosBlur() {
        const nativeElement = this.elementRef.nativeElement;
        fromEvent(nativeElement, 'focusin')
            .pipe(filter(event => nativeElement.contains(event.target)), switchMap(() => merge(fromEvent(this.document, 'focusin'), fromEvent(this.document, 'click'))), filter(event => !nativeElement.contains(event.target)), takeUntil(merge(this.radios.changes, this.destroy$))).subscribe(() => this.onTouched());
    }
    updateValueFromCheckedOption() {
        const checkedRadio = this.radios.find((radio) => radio.checked);
        const missingValue = this.value === undefined || this.value === null;
        if (checkedRadio && missingValue && checkedRadio.value !== this.value) {
            this.writeValue(checkedRadio.value);
            this.propagateValue(checkedRadio.value);
        }
    }
}
VlRadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioGroupComponent, deps: [{ token: i0.ElementRef }, { token: DOCUMENT }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlRadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlRadioGroupComponent, selector: "vl-radio-group", inputs: { value: "value", status: "status", name: "name", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, host: { properties: { "class": "this.class" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlRadioGroupComponent),
            multi: true,
        }], queries: [{ propertyName: "radios", predicate: VlRadioComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ng-content select=\"vl-radio\"></ng-content>", styles: [":host{display:flex;flex-direction:column;gap:.75rem}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-radio-group', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlRadioGroupComponent),
                            multi: true,
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content select=\"vl-radio\"></ng-content>", styles: [":host{display:flex;flex-direction:column;gap:.75rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: VlLayoutService }]; }, propDecorators: { radios: [{
                type: ContentChildren,
                args: [VlRadioComponent, { descendants: true }]
            }], value: [{
                type: Input
            }], status: [{
                type: Input
            }], name: [{
                type: Input
            }], disabled: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const COMPONENTS$5 = [
    VlRadioComponent,
    VlRadioGroupComponent
];
class VlRadioModule {
}
VlRadioModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlRadioModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlRadioModule, declarations: [VlRadioComponent,
        VlRadioGroupComponent], imports: [CommonModule], exports: [VlRadioComponent,
        VlRadioGroupComponent] });
VlRadioModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ...COMPONENTS$5
                    ],
                    exports: [
                        ...COMPONENTS$5
                    ]
                }]
        }] });

class VlSpinnerComponent {
    constructor(cdr, layoutService) {
        this.cdr = cdr;
        this.layoutService = layoutService;
        this.display = false;
        this.status = "primary";
        this.size = "base";
        this.background = false;
        this.sizeClass = {
            "xs": "h-4 w-4",
            "sm": "h-5 w-5",
            "base": "h-6 w-6",
            "lg": "h-7 w-7",
            "xl": "h-8 w-8"
        };
        this.colorClass = {
            "danger": 'border-danger',
            "dark": 'border-dark',
            "info": 'border-info',
            "light": 'border-light',
            "primary": 'border-primary',
            "secondary": 'border-secondary',
            "success": 'border-success',
            "warning": 'border-warning'
        };
    }
    get getBackground() {
        return this.background;
    }
    get indexPositive() {
        return this.display;
    }
    get indexNegative() {
        return !this.display;
    }
    get getColorClass() {
        return this.status ? this.colorClass[this.status] : "";
    }
    get getSizeClass() {
        return this.size ? this.sizeClass[this.size] : "";
    }
    ngOnInit() {
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
}
VlSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSpinnerComponent, selector: "vl-spinner", inputs: { display: "display", status: "status", message: "message", size: "size", background: "background" }, host: { properties: { "class": "this.class", "class.bg-[#8f9bb329]": "this.getBackground", "class.backdrop-blur-[2px]": "this.getBackground", "class.z-[10]": "this.indexPositive", "class.-z-[1]": "this.indexNegative" } }, ngImport: i0, template: "<ng-container *ngIf=\"display\">\n    <div [ngClass]=\"[getSizeClass, getColorClass]\" class=\"border-t-transparent border-solid animate-spin rounded-full border-2\"></div>\n    <span class=\"ml-2\" *ngIf=\"message\">{{ message }}</span>\n</ng-container>", styles: [":host{position:absolute;align-items:center;justify-content:center;display:flex;overflow:hidden;inset:0;border-radius:3px}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"display\">\n    <div [ngClass]=\"[getSizeClass, getColorClass]\" class=\"border-t-transparent border-solid animate-spin rounded-full border-2\"></div>\n    <span class=\"ml-2\" *ngIf=\"message\">{{ message }}</span>\n</ng-container>", styles: [":host{position:absolute;align-items:center;justify-content:center;display:flex;overflow:hidden;inset:0;border-radius:3px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: VlLayoutService }]; }, propDecorators: { display: [{
                type: Input
            }], status: [{
                type: Input
            }], message: [{
                type: Input
            }], size: [{
                type: Input
            }], background: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], getBackground: [{
                type: HostBinding,
                args: ['class.bg-[#8f9bb329]']
            }, {
                type: HostBinding,
                args: ['class.backdrop-blur-[2px]']
            }], indexPositive: [{
                type: HostBinding,
                args: ['class.z-[10]']
            }], indexNegative: [{
                type: HostBinding,
                args: ['class.-z-[1]']
            }] } });

class VlSpinnerDirective {
    constructor(elementRef, viewContainerRef, renderer2) {
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        this.renderer2 = renderer2;
        this.vlSpinnerStatus = "primary";
        this.vlSpinnerSize = "base";
        this.vlSpinnerMessage = null;
        this.vlSpinnerBackground = false;
        this.vlSpinnerClass = "";
        this.exist = false;
        this.shown = false;
        this.initialized = false;
    }
    set vlSpinner(value) {
        //value ? this.show() : this.hide();
        if (this.shown && !value) {
            this.hide();
        }
        this.shown = value;
        if (this.initialized && this.shown) {
            this.show();
        }
    }
    ngOnInit() {
        this.spinner = this.viewContainerRef.createComponent(VlSpinnerComponent);
        this.spinner.instance.message = this.vlSpinnerMessage;
        this.spinner.instance.size = this.vlSpinnerSize;
        this.spinner.instance.status = this.vlSpinnerStatus;
        this.spinner.instance.background = this.vlSpinnerBackground == true;
        this.spinner.instance.class = this.vlSpinnerClass;
        if (this.shown) {
            this.show();
        }
        this.initialized = true;
    }
    ngOnChanges(changes) {
        if (!this.spinner?.instance) {
            return;
        }
        if (changes['vlSpinner']) {
            this.changeSpinnerInstanceInput('display', changes['vlSpinner'].currentValue);
        }
        if (changes['vlSpinnerSize']) {
            this.changeSpinnerInstanceInput('size', changes['vlSpinnerSize'].currentValue);
        }
        if (changes['vlSpinnerStatus']) {
            this.changeSpinnerInstanceInput('status', changes['vlSpinnerStatus'].currentValue);
        }
        if (changes['vlSpinnerMessage']) {
            this.changeSpinnerInstanceInput('message', changes['vlSpinnerMessage'].currentValue);
        }
        if (changes['vlSpinnerBackground']) {
            this.changeSpinnerInstanceInput('background', changes['vlSpinnerBackground'].currentValue);
        }
    }
    changeSpinnerInstanceInput(key, value) {
        this.spinner.instance[key] = value;
        this.spinner.instance.markForCheck();
    }
    ngOnDestroy() {
        this.spinner.destroy();
    }
    hide() {
        if (!this.exist) {
            return;
        }
        this.spinner.instance.display = false;
        this.spinner.instance.background = false;
        this.exist = false;
    }
    show() {
        if (this.exist) {
            return;
        }
        this.spinner.instance.display = true;
        this.spinner.instance.background = this.vlSpinnerBackground;
        this.renderer2.appendChild(this.elementRef.nativeElement, this.spinner.location.nativeElement);
        this.exist = true;
    }
}
VlSpinnerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerDirective, deps: [{ token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
VlSpinnerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: VlSpinnerDirective, selector: "[vlSpinner]", inputs: { vlSpinnerStatus: "vlSpinnerStatus", vlSpinnerSize: "vlSpinnerSize", vlSpinnerMessage: "vlSpinnerMessage", vlSpinnerBackground: "vlSpinnerBackground", vlSpinnerClass: "vlSpinnerClass", vlSpinner: "vlSpinner" }, host: { properties: { "class": "this.class" } }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[vlSpinner]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }]; }, propDecorators: { vlSpinnerStatus: [{
                type: Input
            }], vlSpinnerSize: [{
                type: Input
            }], vlSpinnerMessage: [{
                type: Input
            }], vlSpinnerBackground: [{
                type: Input
            }], vlSpinnerClass: [{
                type: Input
            }], vlSpinner: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlSpinnerContainerComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.status = "danger";
        this.size = "base";
        this.background = false;
        this.heightClass = {
            "xs": "h-4",
            "sm": "h-5",
            "base": "h-6",
            "lg": "h-7",
            "xl": "h-8"
        };
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
    }
    get getSizeClass() {
        return this.heightClass[this.size];
    }
}
VlSpinnerContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerContainerComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlSpinnerContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSpinnerContainerComponent, selector: "vl-spinner-container", inputs: { status: "status", size: "size", background: "background", message: "message" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: `
    <div class="relative" [ngClass]="getSizeClass">
      <vl-spinner [display]="true" [size]="size" [status]="status" [background]="background" [message]="message"></vl-spinner>
    </div>
    `, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: VlSpinnerComponent, selector: "vl-spinner", inputs: ["display", "status", "message", "size", "background"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-spinner-container',
                    template: `
    <div class="relative" [ngClass]="getSizeClass">
      <vl-spinner [display]="true" [size]="size" [status]="status" [background]="background" [message]="message"></vl-spinner>
    </div>
    `,
                }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { status: [{
                type: Input
            }], size: [{
                type: Input
            }], background: [{
                type: Input
            }], message: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlSpinnerModule {
}
VlSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerModule, declarations: [VlSpinnerComponent,
        VlSpinnerDirective,
        VlSpinnerContainerComponent], imports: [CommonModule], exports: [VlSpinnerComponent,
        VlSpinnerDirective,
        VlSpinnerContainerComponent] });
VlSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlSpinnerComponent,
                        VlSpinnerDirective,
                        VlSpinnerContainerComponent
                    ],
                    exports: [
                        VlSpinnerComponent,
                        VlSpinnerDirective,
                        VlSpinnerContainerComponent
                    ]
                }]
        }] });

class VlTooltipComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.text = '';
        this.status = "primary";
        this.leaving = false;
        this.maxWidth = 384;
        this.cssColor = {
            "danger": `text-white ${BACKGROUND_COLOR['danger']}`,
            "dark": `text-white ${BACKGROUND_COLOR['dark']}`,
            "info": `text-white ${BACKGROUND_COLOR['info']}`,
            "light": `text-dark ${BACKGROUND_COLOR['light']}`,
            "primary": `text-white ${BACKGROUND_COLOR['primary']}`,
            "secondary": `text-white ${BACKGROUND_COLOR['secondary']}`,
            "success": `text-white ${BACKGROUND_COLOR['success']}`,
            "warning": `text-white ${BACKGROUND_COLOR['warning']}`,
        };
        this.borderColor = {
            "danger": `border-danger`,
            "dark": `border-dark`,
            "info": `border-info`,
            "light": `border-light`,
            "primary": `border-primary`,
            "secondary": `border-secondary`,
            "success": `border-success`,
            "warning": `border-warning`,
        };
    }
    get cssClass() {
        const leavingClass = this.leaving ? 'scale-0 opacity-0 transition duration-300' : '';
        const status = this.status ?? 'primary';
        return `${this.cssColor[status]} ${leavingClass}`;
    }
    get cssBorderClass() {
        return `${this.borderColor[this.status]}`;
    }
    ngOnInit() {
        this.status = this.layoutService.validateStatus(this.status);
    }
}
VlTooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlTooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTooltipComponent, selector: "vl-tooltip", inputs: { text: "text", status: "status", position: "position", leaving: "leaving", maxWidth: "maxWidth" }, ngImport: i0, template: "<div [@animation] [ngClass]=\"cssClass\" [style.max-width]=\"maxWidth + 'px'\" class=\"w-full relative z-10 inline-block py-0.5 px-1 text-xs rounded shadow-sm\">\n  {{ text }}\n  <span [ngSwitch]=\"position\">\n    <i *ngSwitchCase=\"'top'\" [ngClass]=\"cssBorderClass\" class=\"absolute left-1/2 top-full -translate-x-1/2 border-4 border-x-transparent border-b-transparent\"></i>\n    <i *ngSwitchCase=\"'right'\" [ngClass]=\"cssBorderClass\" class=\"absolute top-1/2 right-full -translate-y-1/2 border-4 border-y-transparent border-l-transparent\"></i>\n    <i *ngSwitchCase=\"'left'\" [ngClass]=\"cssBorderClass\" class=\"absolute top-1/2 left-full -translate-y-1/2 border-4 border-y-transparent border-r-transparent\"></i>\n    <i *ngSwitchCase=\"'bottom'\" [ngClass]=\"cssBorderClass\" class=\"absolute left-1/2 bottom-full -translate-x-1/2 border-4 border-x-transparent border-t-transparent\"></i>\n  </span>\n</div>", styles: [":host{pointer-events:none}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i2.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], animations: [
        trigger('animation', [
            transition(':enter', [
                style({
                    opacity: 0,
                    transform: 'scale(0.8)'
                }),
                animate('0.15s ease-in-out', style({
                    opacity: 1,
                    transform: 'scale(1)'
                }))
            ]),
            transition(':leave', [
                style({
                    opacity: 1,
                    transform: 'scale(1)'
                }),
                animate('0.15s ease-in-out', style({
                    opacity: 0,
                    transform: 'scale(0.8)'
                }))
            ])
        ])
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-tooltip', animations: [
                        trigger('animation', [
                            transition(':enter', [
                                style({
                                    opacity: 0,
                                    transform: 'scale(0.8)'
                                }),
                                animate('0.15s ease-in-out', style({
                                    opacity: 1,
                                    transform: 'scale(1)'
                                }))
                            ]),
                            transition(':leave', [
                                style({
                                    opacity: 1,
                                    transform: 'scale(1)'
                                }),
                                animate('0.15s ease-in-out', style({
                                    opacity: 0,
                                    transform: 'scale(0.8)'
                                }))
                            ])
                        ])
                    ], template: "<div [@animation] [ngClass]=\"cssClass\" [style.max-width]=\"maxWidth + 'px'\" class=\"w-full relative z-10 inline-block py-0.5 px-1 text-xs rounded shadow-sm\">\n  {{ text }}\n  <span [ngSwitch]=\"position\">\n    <i *ngSwitchCase=\"'top'\" [ngClass]=\"cssBorderClass\" class=\"absolute left-1/2 top-full -translate-x-1/2 border-4 border-x-transparent border-b-transparent\"></i>\n    <i *ngSwitchCase=\"'right'\" [ngClass]=\"cssBorderClass\" class=\"absolute top-1/2 right-full -translate-y-1/2 border-4 border-y-transparent border-l-transparent\"></i>\n    <i *ngSwitchCase=\"'left'\" [ngClass]=\"cssBorderClass\" class=\"absolute top-1/2 left-full -translate-y-1/2 border-4 border-y-transparent border-r-transparent\"></i>\n    <i *ngSwitchCase=\"'bottom'\" [ngClass]=\"cssBorderClass\" class=\"absolute left-1/2 bottom-full -translate-x-1/2 border-4 border-x-transparent border-t-transparent\"></i>\n  </span>\n</div>", styles: [":host{pointer-events:none}\n"] }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { text: [{
                type: Input
            }], status: [{
                type: Input
            }], position: [{
                type: Input
            }], leaving: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }] } });

class VlTooltiprRef {
    constructor() {
        this.hidden$ = new Subject();
        this.shown$ = new Subject();
        this.destroyed$ = new Subject();
    }
    get onHidden() {
        return this.hidden$.asObservable();
    }
    get onShown() {
        return this.shown$.asObservable();
    }
    get onDestroy() {
        return this.destroyed$.asObservable();
    }
    destroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    hide() {
        if (!this.isShown) {
            return;
        }
        this.isShown = false;
        this.hidden$.next();
    }
    show(text, status, maxWidth) {
        if (this.isShown) {
            return;
        }
        this.isShown = true;
        this.shown$.next({ text: text, status: status, maxWidth: maxWidth });
    }
}

class VlTooltipService {
    constructor(overlayPositionBuilder, overlay) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.overlay = overlay;
        this.overlayPositions = {
            'top': {
                overlayX: 'center',
                overlayY: 'bottom',
                originX: 'center',
                originY: 'top',
                offsetY: -5
            },
            'bottom': {
                overlayX: 'center',
                overlayY: 'top',
                originX: 'center',
                originY: 'bottom',
                offsetY: 2
            },
            'left': {
                originX: 'start',
                originY: 'center',
                overlayX: 'end',
                overlayY: 'center',
                offsetX: -5,
                offsetY: -2
            },
            'right': {
                originX: 'end',
                originY: 'center',
                overlayX: 'start',
                overlayY: 'center',
                offsetX: 5,
                offsetY: -2
            }
        };
        this.unsubscribe$ = new Subject();
    }
    create(elementRef, position) {
        this.position = position;
        const tooltipRef = new VlTooltiprRef();
        this.positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(elementRef)
            .withPositions([this.overlayPositions[position]]);
        this.scrollStrategy = this.overlay.scrollStrategies.reposition();
        this.subscriptions(tooltipRef);
        return tooltipRef;
    }
    subscriptions(tooltipRef) {
        tooltipRef.onHidden
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => this.hide(tooltipRef));
        tooltipRef.onShown
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((value) => this.show(tooltipRef, value.text, value.status, value.maxWidth));
        tooltipRef.onDestroy
            .pipe(take(1))
            .subscribe(() => this.destroy(tooltipRef));
    }
    destroy(tooltipRef) {
        tooltipRef.componentRef.instance.leaving = true;
        setTimeout(() => {
            tooltipRef?.overlayRef?.detach();
            tooltipRef?.overlayRef?.dispose();
        }, 150);
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    show(tooltipRef, text, status, maxWidth) {
        if (!tooltipRef.overlayRef) {
            tooltipRef.overlayRef = this.overlay.create({ positionStrategy: this.positionStrategy, scrollStrategy: this.scrollStrategy });
            tooltipRef.overlayRef
                .backdropClick()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(() => this.hide(tooltipRef));
        }
        const componentRef = tooltipRef.overlayRef.attach(new ComponentPortal(VlTooltipComponent));
        componentRef.instance.text = text;
        componentRef.instance.status = status;
        componentRef.instance.position = this.position;
        componentRef.instance.maxWidth = maxWidth;
        tooltipRef.componentRef = componentRef;
    }
    hide(tooltipRef) {
        tooltipRef.overlayRef?.detach();
    }
}
VlTooltipService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipService, deps: [{ token: i1.OverlayPositionBuilder }, { token: i1.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
VlTooltipService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.OverlayPositionBuilder }, { type: i1.Overlay }]; } });

class VlTooltipDirective {
    constructor(vlTooltipService, elementRef) {
        this.vlTooltipService = vlTooltipService;
        this.elementRef = elementRef;
        this.text = '';
        this.position = 'top';
        this.status = 'primary';
        this.maxWidth = 384;
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.tooltipRef?.destroy();
    }
    show() {
        if (!this.text?.trim()?.length) {
            return;
        }
        this.tooltipRef = this.vlTooltipService.create(this.elementRef, this.position);
        this.tooltipRef?.show(this.text, this.status, this.maxWidth);
    }
    hide() {
        this.tooltipRef?.destroy();
    }
}
VlTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipDirective, deps: [{ token: VlTooltipService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
VlTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: VlTooltipDirective, selector: "[vlTooltip]", inputs: { text: ["vlTooltip", "text"], position: ["vlTooltipPosition", "position"], status: ["vlTooltipStatus", "status"], maxWidth: ["vlTooltipMaxWidth", "maxWidth"] }, host: { listeners: { "mouseenter": "show()", "focus": "show()", "mouseleave": "hide()", "blur": "hide()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[vlTooltip]' }]
        }], ctorParameters: function () { return [{ type: VlTooltipService }, { type: i0.ElementRef }]; }, propDecorators: { text: [{
                type: Input,
                args: ['vlTooltip']
            }], position: [{
                type: Input,
                args: ['vlTooltipPosition']
            }], status: [{
                type: Input,
                args: ['vlTooltipStatus']
            }], maxWidth: [{
                type: Input,
                args: ['vlTooltipMaxWidth']
            }], show: [{
                type: HostListener,
                args: ['mouseenter']
            }, {
                type: HostListener,
                args: ['focus']
            }], hide: [{
                type: HostListener,
                args: ['mouseleave']
            }, {
                type: HostListener,
                args: ['blur']
            }] } });

class VlTabComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.active = false;
        this.disabled = false;
        this.boolean = false;
    }
    ngOnInit() {
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
}
VlTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
VlTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTabComponent, selector: "vl-tab", inputs: { id: "id", title: "title", icon: "icon", active: "active", disabled: "disabled", boolean: "boolean" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: '<ng-content *ngIf="active && !disabled"></ng-content>', isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-tab', template: '<ng-content *ngIf="active && !disabled"></ng-content>', changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { id: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], active: [{
                type: Input
            }], disabled: [{
                type: Input
            }], boolean: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });
class VlTabsComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.changeTab = new EventEmitter;
        this.status = "primary";
        this.preventDoubleClick = true;
        this.vertical = false;
        this.cssColor = {
            "danger": '!text-dark hover:border-danger',
            "dark": '!text-light hover:border-dark',
            "info": '!text-dark hover:border-info',
            "light": '!text-dark hover:border-light',
            "primary": '!text-dark hover:border-primary',
            "secondary": '!text-dark hover:border-secondary',
            "success": '!text-dark hover:border-success',
            "warning": '!text-dark hover:border-waring',
        };
        this.cssColorDisable = {
            "danger": '!text-dark/75 !border-transparent',
            "dark": '!text-light/75 !border-transparent',
            "info": '!text-dark/75 !border-transparent',
            "light": '!text-dark/75 !border-transparent',
            "primary": '!text-dark/75 b!order-transparent',
            "secondary": '!text-dark/75 !border-transparent',
            "success": '!text-dark/75 !border-transparent',
            "warning": '!text-dark/75 !border-transparent'
        };
        this.cssColorActive = {
            "danger": '!border-danger',
            "dark": '!border-dark',
            "info": '!border-info',
            "light": '!border-light',
            "primary": '!border-primary',
            "secondary": '!border-secondary',
            "success": '!border-success',
            "warning": '!border-warning',
        };
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes['vertical']) {
            this.fixDefaultIcons();
        }
    }
    ngAfterContentInit() {
        if (!this.tabs?.length) {
            return;
        }
        // Using a timeout, we need this to emit when the components is init on all parent
        setTimeout(() => {
            this.fixDefaultIcons();
            const activeTabs = this.tabs?.filter((tab) => tab.active);
            if (!activeTabs?.length || activeTabs.length > 1) {
                const firstTab = Array.from(this.tabs)[0];
                this.updateTab((tab) => tab.active = tab == firstTab, true);
                this.changeTab.emit(firstTab);
                this.cdr.markForCheck();
            }
            else {
                this.updateTab((tab) => tab.active = tab == activeTabs[0], true);
                this.changeTab.emit(activeTabs[0]);
                this.cdr.markForCheck();
            }
        });
    }
    fixDefaultIcons() {
        if (!this.vertical || !this.tabs?.length) {
            return;
        }
        for (let tab of Array.from(this.tabs)) {
            if (tab.icon) {
                continue;
            }
            tab.icon = {
                pack: 'font-awesome-solid',
                icon: 'stream',
                status: this.status
            };
            tab.markForCheck();
        }
    }
    selectTabById(value) {
        this.selectTab("id", value);
    }
    selectTabByTitle(value) {
        this.selectTab("title", value);
    }
    cssClass(tab) {
        const border = this.vertical ? 'border-r-2 !rounded-none' : 'border-b-2';
        if (tab.active) {
            return `${border} ${this.cssColorActive[this.status]}`;
        }
        if (tab.disabled) {
            return `pointer-events-none ${border} ${this.cssColorDisable[this.status]}`;
        }
        return `${border} ${this.cssColor[this.status]}`;
    }
    tabClicked(tabClicked, event) {
        event.preventDefault();
        if (tabClicked.disabled || tabClicked.active && this.preventDoubleClick) {
            return;
        }
        this.updateTab((tab) => tab.active = tab == tabClicked, true);
        this.changeTab.emit(tabClicked);
    }
    selectTab(by, value) {
        if (!this.tabs?.length) {
            return;
        }
        const selectedTab = this.tabs.find((tab) => tab[by] == value);
        if (!selectedTab || selectedTab.disabled) {
            return;
        }
        this.updateTab((tab) => tab.active = tab == selectedTab, true);
        this.changeTab.emit(selectedTab);
        this.cdr.markForCheck();
    }
    updateTab(updateFn, markForCheck = false) {
        if (!this.tabs) {
            return;
        }
        for (let tab of this.tabs) {
            updateFn(tab);
            if (markForCheck) {
                tab.markForCheck();
            }
        }
    }
}
VlTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabsComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
VlTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTabsComponent, selector: "vl-tabs", inputs: { status: "status", preventDoubleClick: "preventDoubleClick", vertical: "vertical" }, outputs: { changeTab: "changeTab" }, host: { properties: { "class.flex": "this.vertical" } }, queries: [{ propertyName: "tabs", predicate: VlTabComponent }], usesOnChanges: true, ngImport: i0, template: "<div [ngClass]=\"vertical ? 'border-r':'border-b'\" class=\"border-light\">\n  <ul class=\"flex flex-wrap gap-2 font-medium text-center\" [ngClass]=\"{'flex-col': vertical}\">\n    <li *ngFor=\"let tab of tabs\">\n      <a (click)=\"tabClicked(tab, $event)\" [vlTooltip]=\"vertical ? tab.title:null\" [vlTooltipStatus]=\"status\" vlTooltipPosition=\"right\" [ngClass]=\"cssClass(tab)\" class=\"gap-2 text-sm font-bold uppercase border-transparent cursor-pointer inline-flex p-3 rounded-t group\">\n        <vl-icon *ngIf=\"tab.icon && vertical || tab.icon && !vertical && tab.icon.horizontal\" class=\"w-5\" [icon]=\"tab.icon.icon\" [pack]=\"tab.icon.pack\" [status]=\"tab.icon.status\"></vl-icon>\n        <span *ngIf=\"!vertical\">{{ tab.title }}</span>\n      </a>\n    </li>\n  </ul>\n</div>\n\n<div class=\"tab-container overflow-auto px-5\" [ngClass]=\"vertical ? 'mt-3':'mt-4'\">\n  <ng-content select=\"vl-tab\"></ng-content>\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }, { kind: "directive", type: VlTooltipDirective, selector: "[vlTooltip]", inputs: ["vlTooltip", "vlTooltipPosition", "vlTooltipStatus", "vlTooltipMaxWidth"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-tabs', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"vertical ? 'border-r':'border-b'\" class=\"border-light\">\n  <ul class=\"flex flex-wrap gap-2 font-medium text-center\" [ngClass]=\"{'flex-col': vertical}\">\n    <li *ngFor=\"let tab of tabs\">\n      <a (click)=\"tabClicked(tab, $event)\" [vlTooltip]=\"vertical ? tab.title:null\" [vlTooltipStatus]=\"status\" vlTooltipPosition=\"right\" [ngClass]=\"cssClass(tab)\" class=\"gap-2 text-sm font-bold uppercase border-transparent cursor-pointer inline-flex p-3 rounded-t group\">\n        <vl-icon *ngIf=\"tab.icon && vertical || tab.icon && !vertical && tab.icon.horizontal\" class=\"w-5\" [icon]=\"tab.icon.icon\" [pack]=\"tab.icon.pack\" [status]=\"tab.icon.status\"></vl-icon>\n        <span *ngIf=\"!vertical\">{{ tab.title }}</span>\n      </a>\n    </li>\n  </ul>\n</div>\n\n<div class=\"tab-container overflow-auto px-5\" [ngClass]=\"vertical ? 'mt-3':'mt-4'\">\n  <ng-content select=\"vl-tab\"></ng-content>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { tabs: [{
                type: ContentChildren,
                args: [VlTabComponent]
            }], changeTab: [{
                type: Output
            }], status: [{
                type: Input
            }], preventDoubleClick: [{
                type: Input
            }], vertical: [{
                type: HostBinding,
                args: ['class.flex']
            }, {
                type: Input
            }] } });

class VlTooltipModule {
}
VlTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipModule, declarations: [VlTooltipDirective,
        VlTooltipComponent], imports: [CommonModule], exports: [VlTooltipDirective] });
VlTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlTooltipDirective,
                        VlTooltipComponent
                    ],
                    exports: [
                        VlTooltipDirective
                    ]
                }]
        }] });

const COMPONENTS$4 = [
    VlTabsComponent,
    VlTabComponent,
];
class VlTabsModule {
}
VlTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlTabsModule, declarations: [VlTabsComponent,
        VlTabComponent], imports: [CommonModule,
        VlIconModule,
        VlTooltipModule], exports: [VlTabsComponent,
        VlTabComponent] });
VlTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabsModule, imports: [CommonModule,
        VlIconModule,
        VlTooltipModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlIconModule,
                        VlTooltipModule
                    ],
                    declarations: [
                        ...COMPONENTS$4
                    ],
                    exports: [
                        ...COMPONENTS$4
                    ]
                }]
        }] });

class VlTimelineContentComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlTimelineContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlTimelineContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineContentComponent, selector: "vl-timeline-content", ngImport: i0, template: "<div class=\"mt-3 text-dark border-light-500 p-3 text-xs italic font-normal border rounded-lg\">\n  <ng-content></ng-content>\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline-content', template: "<div class=\"mt-3 text-dark border-light-500 p-3 text-xs italic font-normal border rounded-lg\">\n  <ng-content></ng-content>\n</div>" }]
        }], ctorParameters: function () { return []; } });

class VlTimelineDateComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlTimelineDateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineDateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlTimelineDateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineDateComponent, selector: "vl-timeline-date", ngImport: i0, template: "<time class=\"text-dark-200 flex text-xs leading-5 font-normal sm:order-last sm:mb-0\">\n    <ng-content></ng-content>\n</time>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineDateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline-date', template: "<time class=\"text-dark-200 flex text-xs leading-5 font-normal sm:order-last sm:mb-0\">\n    <ng-content></ng-content>\n</time>" }]
        }], ctorParameters: function () { return []; } });

class VlTimelineFooterComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlTimelineFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlTimelineFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineFooterComponent, selector: "vl-timeline-footer", ngImport: i0, template: "<time class=\"text-dark-200  pt-3 flex text-xs font-normal\">\n  <ng-content></ng-content>\n</time>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline-footer', template: "<time class=\"text-dark-200  pt-3 flex text-xs font-normal\">\n  <ng-content></ng-content>\n</time>" }]
        }], ctorParameters: function () { return []; } });

class VlTimelineItemComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.status = 'light';
    }
    get dynamicCssClass() {
        return BACKGROUND_COLOR[this.status];
    }
    ngOnInit() {
        this.status = this.layoutService.validateStatus(this.status);
    }
}
VlTimelineItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineItemComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlTimelineItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineItemComponent, selector: "vl-timeline-item", inputs: { status: "status", image: "image", icon: "icon" }, ngImport: i0, template: "<li class=\"mb-3 ml-6\">\n  <span [ngClass]=\"dynamicCssClass\" class=\"ring-white   absolute flex items-center justify-center w-6 h-6 rounded-full -left-3 ring-8\">\n    <img *ngIf=\"image\" class=\"rounded-full shadow-lg\" [src]=\"image\" />\n    <vl-icon *ngIf=\"icon\" [class]=\"icon.css\" [icon]=\"icon.icon\" [size]=\"icon.size\" [pack]=\"icon.pack\" [status]=\"icon.status\" class=\"rounded-full\"></vl-icon>\n  </span>\n  <div class=\"px-3 pb-3\">\n    <div class=\"justify-between sm:flex\">\n      <ng-content select=\"vl-timeline-title\"></ng-content>\n      <ng-content select=\"vl-timeline-date\"></ng-content>\n    </div>\n\n    <ng-content select=\"vl-timeline-content\"></ng-content>\n    <ng-content select=\"vl-timeline-footer\"></ng-content>\n  </div>\n</li>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline-item', template: "<li class=\"mb-3 ml-6\">\n  <span [ngClass]=\"dynamicCssClass\" class=\"ring-white   absolute flex items-center justify-center w-6 h-6 rounded-full -left-3 ring-8\">\n    <img *ngIf=\"image\" class=\"rounded-full shadow-lg\" [src]=\"image\" />\n    <vl-icon *ngIf=\"icon\" [class]=\"icon.css\" [icon]=\"icon.icon\" [size]=\"icon.size\" [pack]=\"icon.pack\" [status]=\"icon.status\" class=\"rounded-full\"></vl-icon>\n  </span>\n  <div class=\"px-3 pb-3\">\n    <div class=\"justify-between sm:flex\">\n      <ng-content select=\"vl-timeline-title\"></ng-content>\n      <ng-content select=\"vl-timeline-date\"></ng-content>\n    </div>\n\n    <ng-content select=\"vl-timeline-content\"></ng-content>\n    <ng-content select=\"vl-timeline-footer\"></ng-content>\n  </div>\n</li>" }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { status: [{
                type: Input
            }], image: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

class VlTimelineTitleComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlTimelineTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineTitleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlTimelineTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineTitleComponent, selector: "vl-timeline-title", ngImport: i0, template: "<div class=\"text-dark    text-sm font-normal flex\">\n    <ng-content></ng-content>\n</div>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline-title', template: "<div class=\"text-dark    text-sm font-normal flex\">\n    <ng-content></ng-content>\n</div>" }]
        }], ctorParameters: function () { return []; } });

/*@Component({
  selector: 'vl-timeline-item',
  template: `
    <!-- <div class="p-3">
      <div class="timeline-icon status-transparent">
        <ng-content select="vl-timeline-icon"></ng-content>
      </div>
      <div class="timeline-date">
        <ng-content select="vl-timeline-date"></ng-content>
      </div>

      <div class="timeline-content">
        <ng-content select="vl-timeline-content"></ng-content>
      </div>
    </div> -->

    <li class="mb-10 ml-6">
      <ng-content select="vl-timeline-icon"></ng-content>
    </li>
  `,
})
export class VlTimelineItemComponent {

}

@Component({
  selector: 'vl-timeline-icon',
  template: '<ng-content></ng-content>',
})
export class VlTimelineIconComponent {

}

@Component({
  selector: 'vl-timeline-date',
  template: '<ng-content></ng-content>',
})
export class VlTimelineDateComponent {

}

@Component({
  selector: 'vl-timeline-content',
  template: '<ng-content></ng-content>',
})
export class VlTimelineContentComponent {

}*/
class VlTimelineComponent {
    constructor() { }
    ngOnInit() {
    }
}
VlTimelineComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlTimelineComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTimelineComponent, selector: "vl-timeline", ngImport: i0, template: "<ol class=\"relative border-l border-light\">\n    <ng-content select=\"vl-timeline-item\"></ng-content>\n</ol>", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-timeline', template: "<ol class=\"relative border-l border-light\">\n    <ng-content select=\"vl-timeline-item\"></ng-content>\n</ol>" }]
        }], ctorParameters: function () { return []; } });

const COMPONENTS$3 = [
    VlTimelineComponent,
    VlTimelineDateComponent,
    VlTimelineItemComponent,
    VlTimelineContentComponent,
    VlTimelineFooterComponent,
    VlTimelineTitleComponent
];
class VlTimelineModule {
}
VlTimelineModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlTimelineModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineModule, declarations: [VlTimelineComponent,
        VlTimelineDateComponent,
        VlTimelineItemComponent,
        VlTimelineContentComponent,
        VlTimelineFooterComponent,
        VlTimelineTitleComponent], imports: [CommonModule,
        VlIconModule], exports: [VlTimelineComponent,
        VlTimelineDateComponent,
        VlTimelineItemComponent,
        VlTimelineContentComponent,
        VlTimelineFooterComponent,
        VlTimelineTitleComponent] });
VlTimelineModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineModule, imports: [CommonModule,
        VlIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTimelineModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlIconModule
                    ],
                    declarations: [
                        ...COMPONENTS$3
                    ],
                    exports: [
                        ...COMPONENTS$3
                    ]
                }]
        }] });

class VlToggleComponent {
    constructor(elementRef, renderer, changeDetector, layoutService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.changeDetector = changeDetector;
        this.layoutService = layoutService;
        this.checkedChange = new EventEmitter();
        this.isDisabled = false;
        this.isChecked = false;
        this.onChange = () => { };
        this.onTouched = () => { };
        this.cssColor = {
            "danger": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-danger peer-checked:bg-danger',
            "dark": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-dark  peer-checked:bg-dark',
            "info": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-info peer-checked:bg-info',
            "light": 'bg-secondary/50 border-light peer-checked:after:border-dark peer-checked:border-light peer-checked:bg-light',
            "primary": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-primary peer-checked:bg-primary',
            "secondary": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-secondary peer-checked:bg-secondary',
            "success": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-success peer-checked:bg-success',
            "warning": 'bg-secondary/50 border-light peer-checked:after:border-white peer-checked:border-warning peer-checked:bg-warning',
        };
    }
    get disabled() {
        return this.isDisabled;
    }
    set disabled(value) {
        if (this.disabled !== value) {
            this.isDisabled = !this.disabled;
            this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', this.disabled);
        }
    }
    get checked() {
        return this.isChecked;
    }
    set checked(value) {
        this.isChecked = value;
    }
    get enabled() {
        return !this.disabled;
    }
    get cssClass() {
        return this.cssColor[this.status];
    }
    ngOnInit() {
        this.status = this.layoutService.validateStatus(this.status);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.isChecked = value;
        this.changeDetector.markForCheck();
    }
    setDisabledState(value) {
        this.disabled = value;
        this.changeDetector.markForCheck();
    }
    setTouched() {
        this.onTouched();
    }
    inputChange(event) {
        const input = event.target;
        this.onCheckedChange(input.checked);
    }
    toggleClick(event) {
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.onCheckedChange(!this.isChecked);
    }
    onCheckedChange(checked) {
        this.isChecked = checked;
        this.checkedChange.emit(this.isChecked);
        this.onChange(this.isChecked);
    }
}
VlToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlToggleComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlToggleComponent, selector: "vl-toggle", inputs: { status: "status", disabled: "disabled", checked: "checked" }, outputs: { checkedChange: "checkedChange" }, host: { properties: { "class": "this.class", "attr.aria-disabled": "this.disabled", "class.btn-disabled": "this.disabled", "attr.enabled": "this.enabled" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlToggleComponent),
            multi: true,
        }], ngImport: i0, template: "<input type=\"checkbox\" class=\"sr-only peer\" [disabled]=\"disabled\" [checked]=\"checked\" (change)=\"inputChange($event)\" (blur)=\"setTouched()\" (click)=\"$event.stopPropagation()\">\n<div (click)=\"toggleClick($event)\" [ngClass]=\"cssClass\" class=\"w-11 h-6 border peer-disabled:bg-light/100 peer-disabled:border-light cursor-pointer peer-disabled:pointer-events-none_ rounded-full peer peer-focus:0 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-light after:border after:rounded-full after:h-5 after:w-5 after:transition-all\"></div>\n\n<span class=\"ml-2 cursor-pointer peer-disabled:pointer-events-none_\" (click)=\"toggleClick($event)\">\n  <ng-content></ng-content>\n</span>", styles: [":host{position:relative;display:inline-flex;align-items:center;width:-moz-fit-content;width:fit-content}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-toggle', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlToggleComponent),
                            multi: true,
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<input type=\"checkbox\" class=\"sr-only peer\" [disabled]=\"disabled\" [checked]=\"checked\" (change)=\"inputChange($event)\" (blur)=\"setTouched()\" (click)=\"$event.stopPropagation()\">\n<div (click)=\"toggleClick($event)\" [ngClass]=\"cssClass\" class=\"w-11 h-6 border peer-disabled:bg-light/100 peer-disabled:border-light cursor-pointer peer-disabled:pointer-events-none_ rounded-full peer peer-focus:0 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-light after:border after:rounded-full after:h-5 after:w-5 after:transition-all\"></div>\n\n<span class=\"ml-2 cursor-pointer peer-disabled:pointer-events-none_\" (click)=\"toggleClick($event)\">\n  <ng-content></ng-content>\n</span>", styles: [":host{position:relative;display:inline-flex;align-items:center;width:-moz-fit-content;width:fit-content}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: VlLayoutService }]; }, propDecorators: { checkedChange: [{
                type: Output
            }], status: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.aria-disabled']
            }, {
                type: HostBinding,
                args: ['class.btn-disabled']
            }], checked: [{
                type: Input
            }], enabled: [{
                type: HostBinding,
                args: ['attr.enabled']
            }] } });

class VlToggleModule {
}
VlToggleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlToggleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlToggleModule, declarations: [VlToggleComponent], imports: [CommonModule], exports: [VlToggleComponent] });
VlToggleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlToggleModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        VlToggleComponent
                    ],
                    exports: [
                        VlToggleComponent
                    ]
                }]
        }] });

class VlUserComponent {
    constructor() {
        this.displayingImage = true;
    }
    get initial() {
        if (!this.name) {
            return '';
        }
        const names = this.name.split(' ');
        return names.map(n => n.charAt(0)).splice(0, 2).join('');
    }
    ngOnInit() {
    }
}
VlUserComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlUserComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlUserComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlUserComponent, selector: "vl-user", inputs: { displayingImage: "displayingImage", image: "image", name: "name", title: "title" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<div *ngIf=\"displayingImage\" class=\"mr-2 bg-white border-light border-2 font-bold rounded-full h-12 w-12 flex items-center justify-center\">\n  <span *ngIf=\"!image\" class=\"text-lg uppercase\">{{ initial }}</span>\n  <img *ngIf=\"image\" class=\"rounded-full h-12 w-12 object-cover\" [src]=\"image\">\n</div>\n<div class=\"flex flex-col\">\n  <span class=\"font-bold\">{{ name }}</span>\n  <span class=\"font-bold text-xs uppercase\" *ngIf=\"title\">{{ title }}</span>\n</div>", styles: [":host{display:flex;align-items:center}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlUserComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-user', template: "<div *ngIf=\"displayingImage\" class=\"mr-2 bg-white border-light border-2 font-bold rounded-full h-12 w-12 flex items-center justify-center\">\n  <span *ngIf=\"!image\" class=\"text-lg uppercase\">{{ initial }}</span>\n  <img *ngIf=\"image\" class=\"rounded-full h-12 w-12 object-cover\" [src]=\"image\">\n</div>\n<div class=\"flex flex-col\">\n  <span class=\"font-bold\">{{ name }}</span>\n  <span class=\"font-bold text-xs uppercase\" *ngIf=\"title\">{{ title }}</span>\n</div>", styles: [":host{display:flex;align-items:center}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { displayingImage: [{
                type: Input
            }], image: [{
                type: Input
            }], name: [{
                type: Input
            }], title: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlUserModule {
}
VlUserModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlUserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlUserModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlUserModule, declarations: [VlUserComponent], imports: [CommonModule], exports: [VlUserComponent] });
VlUserModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlUserModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlUserModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [VlUserComponent],
                    exports: [VlUserComponent]
                }]
        }] });

class VlWindowContainerComponent {
}
VlWindowContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlWindowContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlWindowContainerComponent, selector: "vl-window-container", viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["viewContainerRef"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: `<ng-container #viewContainerRef></ng-container>`, isInline: true, styles: [":host{display:flex;align-items:flex-end;overflow-x:auto}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-window-container', template: `<ng-container #viewContainerRef></ng-container>`, styles: [":host{display:flex;align-items:flex-end;overflow-x:auto}\n"] }]
        }], propDecorators: { viewContainerRef: [{
                type: ViewChild,
                args: ['viewContainerRef', { read: ViewContainerRef, static: true }]
            }] } });

class VlWindowRef {
    constructor() {
        this.closed = false;
        this.closed$ = new Subject();
    }
    get onClose() {
        return this.closed$.asObservable();
    }
    componentInstance() {
        return this.componentRef.instance.componentInstance();
    }
    /**
     * Set a context value
     *
     * @param context  Context variable
     * @param value    Context value
     */
    setContextValue(context, value) {
        this.componentRef.instance.setContextValue(context, value);
    }
    /**
     * Get a context value
     *
     * @param context  Context variable
     */
    getContextValue(context) {
        this.componentRef.instance.getContextValue(context);
    }
    /**
     * Close the window ref
     */
    close() {
        if (this.closed) {
            return;
        }
        this.closed = true;
        this.componentRef.destroy();
        this.componentRef.instance.targetComponent.clear();
        this.windowContainerViewRef.clear();
        this.overlayRef.detach();
        this.overlayRef.dispose();
        this.closed$.next();
        this.closed$.complete();
    }
}

class VlTemplateRefPipe {
    transform(value) {
        return value;
    }
}
VlTemplateRefPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTemplateRefPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
VlTemplateRefPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlTemplateRefPipe, name: "templateRef" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTemplateRefPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'templateRef' }]
        }] });
var ISize;
(function (ISize) {
    ISize["BIG"] = "BIG";
    ISize["SMALL"] = "SMALL";
})(ISize || (ISize = {}));
class VlWindowComponent {
    constructor(vlWindowRef, renderer, elementRef) {
        this.vlWindowRef = vlWindowRef;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.size = ISize.SMALL;
        this.lastSize = { width: 400, height: 400 };
        this.dragging = false;
        this.resizeConfig = {
            minWitdh: 250,
            minHeight: 200
        };
    }
    ngOnInit() {
        this.titleCustomTemplate = this.title instanceof TemplateRef;
    }
    ngAfterViewInit() {
        if (!(this.component instanceof TemplateRef)) {
            this.componentRef = this.targetComponent.createComponent(this.component);
            Object.assign(this.componentRef.instance, this.context);
        }
        else {
            this.componentRef = this.targetComponent.createEmbeddedView(this.component);
            this.componentRef.context = this.context;
        }
        /*this.bodyWrapper = this.cardBodyWrapper.elementRef;
        this.headerWrapper = this.cardHeaderWrapper.elementRef;
    
        this.lastSize = {
          width: this.bodyWrapper.nativeElement?.offsetWidth,
          height: this.bodyWrapper.nativeElement?.offsetHeight
        }*/
        this.cardWrapper = this.cardParentWrapper.elementRef;
        this.lastSize = {
            width: this.cardWrapper.nativeElement.offsetWidth,
            height: this.cardWrapper.nativeElement?.offsetHeight
        };
    }
    setContextValue(context, value) {
        if (!(this.component instanceof TemplateRef)) {
            this.componentRef.instance.data[context] = value;
        }
        else {
            this.componentRef.context.$implicit[context] = value;
        }
    }
    getContextValue(context) {
        if (!(this.component instanceof TemplateRef)) {
            return this.componentRef.instance.data[context];
        }
        else {
            return this.componentRef.context.$implicit[context];
        }
    }
    componentInstance() {
        if (!(this.component instanceof TemplateRef)) {
            return this.componentRef.instance;
        }
        else {
            return this.componentRef;
        }
    }
    ngOnDestroy() {
        this.close();
    }
    close() {
        this.vlWindowRef.close();
    }
    onDragStart() {
        if (!this.resizable) {
            return;
        }
        this.dragging = true;
    }
    onDragEnd() {
        if (!this.resizable) {
            return;
        }
        this.dragging = false;
    }
    onMouseMove(event) {
        if (!this.dragging || !this.resizable) {
            return;
        }
        this.resize(event, this.cardWrapper.nativeElement, true, true);
        /* this.resize(event, this.bodyWrapper.nativeElement, true, true);
         this.resize(event, this.headerWrapper.nativeElement, true, false);*/
    }
    sizeChange() {
        switch (this.size) {
            case ISize.SMALL:
                this.setSize(this.cardWrapper.nativeElement, window.innerWidth - 20, window.innerHeight - 10);
                /*this.setSize(this.bodyWrapper.nativeElement, window.innerWidth - 20, window.innerHeight - 57);
                this.setSize(this.headerWrapper.nativeElement, window.innerWidth - 20, -1);*/
                this.size = ISize.BIG;
                break;
            case ISize.BIG:
                this.setSize(this.cardWrapper.nativeElement, this.lastSize.width, this.lastSize.height);
                /*this.setSize(this.bodyWrapper.nativeElement, this.lastSize.width, this.lastSize.height);
                this.setSize(this.headerWrapper.nativeElement,  this.lastSize.width, -1);*/
                this.size = ISize.SMALL;
                break;
        }
    }
    resize(event, element, changeWitdh, changeHeight) {
        if (!element?.getBoundingClientRect()) {
            return;
        }
        const { x, y } = element.getBoundingClientRect();
        const height = event.clientY - y;
        const width = event.clientX - x;
        this.lastSize = {
            height: height,
            width: width,
        };
        this.setSize(element, changeWitdh ? width : -1, changeHeight ? height : -1);
    }
    setSize(element, width, height) {
        width = width < this.resizeConfig.minWitdh && width != -1 ? this.resizeConfig.minWitdh : width;
        height = height < this.resizeConfig.minHeight && height != -1 ? this.resizeConfig.minHeight : height;
        if (width != -1 && width <= window.innerWidth - 15) {
            this.renderer.setStyle(element, "width", `${width}px`);
            this.renderer.setStyle(element, "max-width", `${width}px`);
        }
        if (height != -1 && height <= window.innerHeight - 5) {
            this.renderer.setStyle(element, "height", `${height}px`);
            this.renderer.setStyle(element, "max-height", `${height}px`);
        }
    }
}
VlWindowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowComponent, deps: [{ token: VlWindowRef }, { token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlWindowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlWindowComponent, selector: "vl-window", inputs: { title: "title", icon: "icon", component: "component", context: "context", resizable: "resizable" }, host: { listeners: { "window:mousemove": "onMouseMove($event)" }, properties: { "class": "this.class" } }, viewQueries: [{ propertyName: "targetComponent", first: true, predicate: ["targetComponent"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "cardParentWrapper", first: true, predicate: ["card"], descendants: true }], ngImport: i0, template: "<vl-card #card class=\"max-h-[85vh] max-w-[85vw]\">\n  <vl-card-header #cardHeader class=\"flex justify-between items-center min-h-[57px] !w-full\">\n    <div class=\"font-bold tracking-wide flex items-center mr-6\">\n      <vl-icon *ngIf=\"icon\" [pack]=\"icon.pack\" [icon]=\"icon.icon\" [status]=\"icon.status\" size=\"lg\" class=\"mr-2\"></vl-icon>\n\n      <h1 *ngIf=\"!titleCustomTemplate; else titleTemplate\" class=\"text-base\">{{ title }}</h1>\n      <ng-template #titleTemplate>\n        <ng-container *ngTemplateOutlet=\"title | templateRef\"></ng-container>\n      </ng-template>\n    </div>\n    <div class=\"w-36 flex justify-end gap-4\">\n      <vl-icon *ngIf=\"resizable\" pack=\"font-awesome-regular\" [icon]=\"size == 'BIG' ? 'window-restore':'square'\" status=\"dark\" class=\"cursor-pointer\" (click)=\"sizeChange()\"></vl-icon>\n      <vl-icon pack=\"font-awesome-solid\" icon=\"times\" status=\"dark\" class=\"cursor-pointer\" (click)=\"close()\"></vl-icon>\n    </div>\n  </vl-card-header>\n  <vl-card-body #cardBody [ngClass]=\"{'select-none': dragging}\" class=\"overflow-x-hidden overylow-y-auto !w-full\">\n    <vl-icon *ngIf=\"resizable && size == 'SMALL' \" class=\"!fixed right-[2px] bottom-0 cursor-nwse-resize\" (mousedown)=\"onDragStart()\" (window:mouseup)=\"onDragEnd()\" pack=\"font-awesome-solid\" icon=\"arrows-alt\" status=\"dark\"></vl-icon>\n    <ng-container #targetComponent></ng-container>\n\n  </vl-card-body>\n</vl-card>", styles: [":host{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }, { kind: "component", type: VlCardComponent, selector: "vl-card" }, { kind: "component", type: VlCardHeaderComponent, selector: "vl-card-header" }, { kind: "component", type: VlCardBodyComponent, selector: "vl-card-body" }, { kind: "pipe", type: VlTemplateRefPipe, name: "templateRef" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-window', template: "<vl-card #card class=\"max-h-[85vh] max-w-[85vw]\">\n  <vl-card-header #cardHeader class=\"flex justify-between items-center min-h-[57px] !w-full\">\n    <div class=\"font-bold tracking-wide flex items-center mr-6\">\n      <vl-icon *ngIf=\"icon\" [pack]=\"icon.pack\" [icon]=\"icon.icon\" [status]=\"icon.status\" size=\"lg\" class=\"mr-2\"></vl-icon>\n\n      <h1 *ngIf=\"!titleCustomTemplate; else titleTemplate\" class=\"text-base\">{{ title }}</h1>\n      <ng-template #titleTemplate>\n        <ng-container *ngTemplateOutlet=\"title | templateRef\"></ng-container>\n      </ng-template>\n    </div>\n    <div class=\"w-36 flex justify-end gap-4\">\n      <vl-icon *ngIf=\"resizable\" pack=\"font-awesome-regular\" [icon]=\"size == 'BIG' ? 'window-restore':'square'\" status=\"dark\" class=\"cursor-pointer\" (click)=\"sizeChange()\"></vl-icon>\n      <vl-icon pack=\"font-awesome-solid\" icon=\"times\" status=\"dark\" class=\"cursor-pointer\" (click)=\"close()\"></vl-icon>\n    </div>\n  </vl-card-header>\n  <vl-card-body #cardBody [ngClass]=\"{'select-none': dragging}\" class=\"overflow-x-hidden overylow-y-auto !w-full\">\n    <vl-icon *ngIf=\"resizable && size == 'SMALL' \" class=\"!fixed right-[2px] bottom-0 cursor-nwse-resize\" (mousedown)=\"onDragStart()\" (window:mouseup)=\"onDragEnd()\" pack=\"font-awesome-solid\" icon=\"arrows-alt\" status=\"dark\"></vl-icon>\n    <ng-container #targetComponent></ng-container>\n\n  </vl-card-body>\n</vl-card>", styles: [":host{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}\n"] }]
        }], ctorParameters: function () { return [{ type: VlWindowRef }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, propDecorators: { targetComponent: [{
                type: ViewChild,
                args: ['targetComponent', { read: ViewContainerRef, static: true }]
            }], cardParentWrapper: [{
                type: ViewChild,
                args: ['card']
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], component: [{
                type: Input
            }], context: [{
                type: Input
            }], resizable: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }], onMouseMove: [{
                type: HostListener,
                args: ['window:mousemove', ['$event']]
            }] } });

class VlWindowModule {
}
VlWindowModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlWindowModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlWindowModule, declarations: [VlWindowComponent,
        VlWindowContainerComponent,
        VlTemplateRefPipe], imports: [CommonModule,
        VlIconModule,
        VlCardModule] });
VlWindowModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowModule, imports: [CommonModule,
        VlIconModule,
        VlCardModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlIconModule,
                        VlCardModule
                    ],
                    declarations: [
                        VlWindowComponent,
                        VlWindowContainerComponent,
                        VlTemplateRefPipe
                    ],
                    exports: []
                }]
        }] });

const VL_WINDOW_CONTEXT = new InjectionToken('Vl Window Context');
class VlWindowService {
    constructor(overlay) {
        this.overlay = overlay;
        //private windowContainerViewRef: ViewContainerRef;
        //private overlayRef: OverlayRef;
        //private windows: VlWindowRef[] = []
        this.unsubscribe$ = new Subject();
    }
    open(contentComponentType, config) {
        /*if (this.needCreateWindowContainer()) {
          this.createWindowsContainer();
        }*/
        const windowRef = new VlWindowRef();
        const context = contentComponentType instanceof TemplateRef ? { $implicit: config.context, windowRef } : config.context;
        this.createWindowsContainer(windowRef);
        const providers = [
            { provide: VlWindowRef, useValue: windowRef },
            { provide: VL_WINDOW_CONTEXT, useValue: context }
        ];
        const injector = Injector.create({ parent: windowRef.windowContainerViewRef.injector, providers });
        const componentRef = windowRef.windowContainerViewRef.createComponent(VlWindowComponent, { injector: injector });
        if (config.resizable == null) {
            config.resizable = true;
        }
        componentRef.instance.component = contentComponentType;
        componentRef.instance.title = config.title;
        componentRef.instance.icon = config.icon;
        componentRef.instance.resizable = config.resizable;
        componentRef.instance.context = context;
        componentRef.instance.class = config.class;
        //this.windows.push(windowRef);
        //this.changeOverlayBackdropHidden();
        this.subscriptions(windowRef);
        windowRef.componentRef = componentRef;
        componentRef.changeDetectorRef.detectChanges();
        return windowRef;
    }
    /*private needCreateWindowContainer(): boolean {
      if (this.windowContainerViewRef) {
        const containerEl = this.windowContainerViewRef.element.nativeElement;
        return !document.body.contains(containerEl);
      }
  
      return true;
    }*/
    createWindowsContainer(windowRef) {
        /* if (this.overlayRef) {
           this.overlayRef.dispose();
         }
     
         this.overlayRef = this.overlay.create({
           hasBackdrop: true,
           scrollStrategy: this.overlay.scrollStrategies.noop(),
         });
     
         const portal: ComponentPortal<VlWindowContainerComponent> = new ComponentPortal(VlWindowContainerComponent)
         const componentRef: ComponentRef<VlWindowContainerComponent> = this.overlayRef.attach(portal)
         this.windowContainerViewRef = componentRef.instance.viewContainerRef;*/
        windowRef.overlayRef = this.overlay.create({
            hasBackdrop: true,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
        });
        const portal = new ComponentPortal(VlWindowContainerComponent);
        const componentRef = windowRef.overlayRef.attach(portal);
        windowRef.windowContainerViewRef = componentRef.instance.viewContainerRef;
    }
    subscriptions(windowRef) {
        windowRef.overlayRef
            .backdropClick()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            windowRef.close();
        });
        windowRef.overlayRef
            .keydownEvents()
            .pipe(filter((event) => event.keyCode === 27))
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            windowRef.close();
        });
        windowRef
            .onClose
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
            //this.windows.splice(this.windows.indexOf(windowRef), 1);
            //this.changeOverlayBackdropHidden();
            this.unsubscribe();
        });
    }
    unsubscribe() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    changeOverlayBackdropHidden() {
        /*if (this.windows.length) {
          this.overlayRef.backdropElement.removeAttribute('hidden');
        } else {
          this.overlayRef.backdropElement.setAttribute('hidden', '');
        }*/
    }
}
VlWindowService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowService, deps: [{ token: i1.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
VlWindowService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlWindowService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Overlay }]; } });

class VlSelectOptionComponent {
    constructor() {
    }
    get display() {
        return this.label ? this.label : this.value;
    }
}
VlSelectOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectOptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlSelectOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSelectOptionComponent, selector: "vl-select-option", inputs: { value: "value", research: "research", label: "label", class: "class", icon: "icon", templateRef: "templateRef" }, viewQueries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: `
  <ng-template>
    <span *ngIf="!templateRef?.templateRef" [ngClass]="class" class="flex gap-1">
      <vl-icon *ngIf="icon" [pack]="icon.pack" [icon]="icon.icon" [status]="icon.status"></vl-icon>
      {{ display }}
    </span>

    <div class="flex" *ngIf="templateRef?.templateRef">
      <ng-container *ngTemplateOutlet="templateRef.templateRef; context: { value: value, context: templateRef.context }"></ng-container>
    </div>
  </ng-template>`, isInline: true, dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectOptionComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-select-option',
                    template: `
  <ng-template>
    <span *ngIf="!templateRef?.templateRef" [ngClass]="class" class="flex gap-1">
      <vl-icon *ngIf="icon" [pack]="icon.pack" [icon]="icon.icon" [status]="icon.status"></vl-icon>
      {{ display }}
    </span>

    <div class="flex" *ngIf="templateRef?.templateRef">
      <ng-container *ngTemplateOutlet="templateRef.templateRef; context: { value: value, context: templateRef.context }"></ng-container>
    </div>
  </ng-template>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { template: [{
                type: ViewChild,
                args: [TemplateRef]
            }], value: [{
                type: Input
            }], research: [{
                type: Input
            }], label: [{
                type: Input
            }], class: [{
                type: Input
            }], icon: [{
                type: Input
            }], templateRef: [{
                type: Input
            }] } });

class VlSearchInputComponent {
    constructor() {
        this.enter = true;
        this.keyup = false;
        this.button = true;
        this.status = "primary";
        this.placeholder = "";
        this.size = "base";
        this.onSearch = new EventEmitter();
    }
    ngOnInit() {
        if (this.button == false && this.enter == false && this.keyup == false) {
            this.button = true;
            this.enter = true;
        }
    }
    onKeyUp() {
        if (!this.keyup) {
            return;
        }
        this.emitSearch();
    }
    onEnter() {
        if (!this.enter) {
            return;
        }
        this.emitSearch();
    }
    onClick() {
        if (!this.button) {
            return;
        }
        this.emitSearch();
    }
    emitSearch() {
        if (this.disabled) {
            return;
        }
        this.onSearch.emit(this.value);
    }
}
VlSearchInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlSearchInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSearchInputComponent, selector: "vl-search-input", inputs: { disabled: "disabled", enter: "enter", keyup: "keyup", button: "button", status: "status", placeholder: "placeholder", size: "size", value: "value" }, outputs: { onSearch: "onSearch" }, host: { properties: { "class": "this.class" } }, ngImport: i0, template: "<vl-input [(ngModel)]=\"value\" [disabled]=\"disabled\" [ngClass]=\"{'rounded-r-0': button}\" class=\"w-full\" [status]=\"status\" [size]=\"size\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp()\" (keyup.enter)=\"onEnter()\"></vl-input>\n\n<vl-button *ngIf=\"button\" (onClick)=\"onClick()\" [disabled]=\"disabled\" [status]=\"status\" [size]=\"size\" class=\"overflow-visible\">\n  <vl-icon status=\"light\" [size]=\"size\" pack=\"font-awesome-solid\" icon=\"search\"></vl-icon>\n</vl-button>", styles: [":host{display:flex;width:100%;height:-moz-fit-content;height:fit-content}:host ::ng-deep vl-input.rounded-r-0>div{border-top-right-radius:0;border-bottom-right-radius:0}:host ::ng-deep vl-button button{height:100%;border-top-left-radius:0;border-bottom-left-radius:0}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }, { kind: "component", type: VlInputComponent, selector: "vl-input", inputs: ["status", "size", "placeholder", "value", "disabled", "type", "min", "max"], outputs: ["keyup", "blur"] }, { kind: "component", type: VlButtonComponent, selector: "vl-button", inputs: ["rounded", "status", "size", "disabled"], outputs: ["onClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-search-input', template: "<vl-input [(ngModel)]=\"value\" [disabled]=\"disabled\" [ngClass]=\"{'rounded-r-0': button}\" class=\"w-full\" [status]=\"status\" [size]=\"size\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp()\" (keyup.enter)=\"onEnter()\"></vl-input>\n\n<vl-button *ngIf=\"button\" (onClick)=\"onClick()\" [disabled]=\"disabled\" [status]=\"status\" [size]=\"size\" class=\"overflow-visible\">\n  <vl-icon status=\"light\" [size]=\"size\" pack=\"font-awesome-solid\" icon=\"search\"></vl-icon>\n</vl-button>", styles: [":host{display:flex;width:100%;height:-moz-fit-content;height:fit-content}:host ::ng-deep vl-input.rounded-r-0>div{border-top-right-radius:0;border-bottom-right-radius:0}:host ::ng-deep vl-button button{height:100%;border-top-left-radius:0;border-bottom-left-radius:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { disabled: [{
                type: Input
            }], enter: [{
                type: Input
            }], keyup: [{
                type: Input
            }], button: [{
                type: Input
            }], status: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], size: [{
                type: Input
            }], value: [{
                type: Input
            }], onSearch: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlSelectLabelComponent {
}
VlSelectLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlSelectLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSelectLabelComponent, selector: "vl-select-label", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectLabelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-select-label',
                    template: '<ng-content></ng-content>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
class VlSelectComponent {
    constructor(changeDetector, elemRef, layoutService) {
        this.changeDetector = changeDetector;
        this.elemRef = elemRef;
        this.layoutService = layoutService;
        this.selectedChange = new EventEmitter();
        this.lazyOnLoadPage = new EventEmitter();
        this.lazy = false;
        this.lazyLoadingFirstPage = false;
        this.lazyLoadingNextPage = false;
        this.lazyLoadingLimitReached = false;
        this.disabled = false;
        this.multiple = false;
        this.status = "primary";
        this.placeholder = "Select a value";
        this.size = "base";
        this.selected = null;
        this.search = false;
        this.itemSize = 35;
        this.fullWidth = true;
        this.onChange = () => { };
        this.onTouched = () => { };
        this.isDisplayed = false;
        this.options = [];
        this.selectedCachedOptions = [];
        this.displayedOptions = [];
        this.selections = [];
        this.searchValue = null;
        this.changeBySelectedValue = false;
        this.destroy$ = new Subject();
        this.virtualScrollConfig = {
            heightPx: 200,
            minItem: 50
        };
        this.cssColorActive = {
            single: {
                "danger": 'bg-danger text-white',
                "dark": 'bg-dark text-white',
                "info": 'bg-info text-dark',
                "light": 'bg-light text-white',
                "primary": 'bg-primary text-white',
                "secondary": 'bg-secondary text-white',
                "success": 'bg-success text-white',
                "warning": 'bg-warning text-white'
            },
            multiple: {
                "danger": 'hover:bg-light/75',
                "dark": 'hover:bg-light/75',
                "info": 'hover:bg-light/75',
                "light": 'hover:bg-light/75',
                "primary": 'hover:bg-light/75',
                "secondary": 'hover:bg-light/75',
                "success": 'hover:bg-light/75',
                "warning": 'hover:bg-light/75'
            }
        };
        this.cssColorHover = {
            single: {
                "danger": 'hover:bg-light/75',
                "dark": 'hover:bg-light/75',
                "info": 'hover:bg-light/75',
                "light": 'hover:bg-light/75',
                "primary": 'hover:bg-light/75',
                "secondary": 'hover:bg-light/75',
                "success": 'hover:bg-light/75',
                "warning": 'hover:bg-light/75'
            },
            multiple: {
                "danger": 'hover:bg-light/75',
                "dark": 'hover:bg-light/75',
                "info": 'hover:bg-light/75',
                "light": 'hover:bg-light/75',
                "primary": 'hover:bg-light/75',
                "secondary": 'hover:bg-light/75',
                "success": 'hover:bg-light/75',
                "warning": 'hover:bg-light/75'
            }
        };
    }
    get display() {
        return this.isDisplayed;
    }
    set display(value) {
        if (this.disabled) {
            return;
        }
        this.isDisplayed = value;
    }
    get value() {
        return this.innerValue;
    }
    set value(value) {
        this.innerValue = value;
        this.onChange(value);
    }
    get dropdownWidth() {
        /*const scrollbarWidth: number = this.dropdown?.nativeElement?.offsetWidth - this.dropdown?.nativeElement?.clientWidth;
        return this.button?.elementRef?.nativeElement?.offsetWidth - scrollbarWidth;*/
        const btnWitdh = this.button?.elementRef?.nativeElement?.offsetWidth;
        return btnWitdh < 240 ? 240 : btnWitdh;
    }
    onClick(event) {
        if (!this?.isDisplayed) {
            return;
        }
        // Click on button
        if (event.target == this.button.elementRef.nativeElement) {
            return;
        }
        let clickedInside = this.dropdown?.nativeElement?.contains(event.target);
        if (!clickedInside) {
            this.isDisplayed = false;
            this.searchValue = null;
        }
    }
    get elementRef() {
        return this.elemRef;
    }
    ngOnInit() {
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
    }
    ngOnChanges(changes) {
        if (changes['multiple']) {
            this.multiple = changes['multiple'].currentValue;
            this.changeDetector.markForCheck();
        }
        if (changes['lazyLoadingFirstPage']) {
            this.lazyLoadingFirstPage = changes['lazyLoadingFirstPage'].currentValue;
            this.changeDetector.markForCheck();
        }
        if (changes['lazyLoadingNextPage']) {
            this.lazyLoadingNextPage = changes['lazyLoadingNextPage'].currentValue;
            this.changeDetector.markForCheck();
        }
        if (changes['selected']) {
            if (this.changeBySelectedValue) {
                this.value = changes['selected'].currentValue;
                this.preselectValue();
            }
        }
    }
    ngAfterViewInit() {
        // Subscribe to change, if an option is added, catching it :)
        this.inputOptions?.changes
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
            this.options = this.inputOptions?.toArray();
            this.displayedOptions = this.options;
            this.changeDetector.markForCheck();
            setTimeout(() => {
                if (this.lazy) {
                    this.cdkVirtualScrollViewport?.checkViewportSize();
                }
                this.preselectValue();
            });
        });
        this.options = this.inputOptions?.toArray();
        this.displayedOptions = clone(this.options);
        setTimeout(() => {
            if (this.value == undefined) {
                this.value = this.selected;
                this.changeBySelectedValue = true;
            }
            this.preselectValue();
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        this.value = value;
        this.setSelection();
        this.changeDetector.markForCheck();
    }
    setTouched() {
        this.onTouched();
    }
    preselectValue() {
        if (!this.value && (this.selected == null || this.selected == undefined)) {
            return;
        }
        this.setSelection();
        this.changeDetector.markForCheck();
    }
    onSelectChange(option, index) {
        if (this.disabled) {
            return;
        }
        if (!this.multiple) {
            this.display = false;
        }
        if (!this.multiple) {
            this.writeValue(option.value);
            this.selectedChange.emit(option.value);
            return;
        }
        let arrayValue = clone(this.value);
        let optionValue = option.value;
        // Can be null, fix it 
        if (!arrayValue || !Array.isArray(arrayValue)) {
            arrayValue = [];
        }
        if (arrayValue.includes(optionValue)) {
            arrayValue.splice(arrayValue.indexOf(optionValue), 1);
        }
        else {
            arrayValue.push(optionValue);
        }
        this.writeValue(arrayValue);
        this.selectedChange.emit(arrayValue);
    }
    setSelection() {
        // Getting all the options and merge with selectedCachedOptions to have a real cache, removing duplication  
        this.selectedCachedOptions = union(this.selectedCachedOptions, this.options);
        if (!this.multiple) {
            const option = this.selectedCachedOptions.find((option) => option.value == this.value);
            this.selections = option == null ? null : [option];
        }
        else {
            const options = [];
            if (this.value?.length) {
                for (let value of this.value) {
                    const option = this.selectedCachedOptions.find((option) => option.value == value);
                    options.push(option);
                }
            }
            this.selections = options;
        }
    }
    cssClass(option) {
        if (this.optionIsSelected(option)) {
            return !this.multiple ? this.cssColorActive.single[this.status] : this.cssColorActive.multiple[this.status];
        }
        return !this.multiple ? this.cssColorHover.single[this.status] : this.cssColorHover.multiple[this.status];
    }
    optionIsSelected(option) {
        return !this.multiple && option.value == this.value || this.multiple && this.value?.includes(option.value);
    }
    onSelectClick() {
        if (this.disabled) {
            return;
        }
        this.display = !this.display;
        if (!this.lazy || this.lazy && this.display) {
            this.onSearch(""); // Reset search
        }
    }
    onSearch(value) {
        if (typeof value == "string") {
            value = value.toLocaleLowerCase();
        }
        if (!this.search) {
            return;
        }
        this.searchValue = value;
        if (this.lazy) {
            this.displayedOptions = [];
            this.lazyLoadingLimitReached = false;
            this.loadingLazyPage(true);
            return;
        }
        if (!value?.trim()?.length) {
            this.displayedOptions = clone(this.options);
            return;
        }
        this.displayedOptions = [];
        for (let option of this.options) {
            if (this.searchKey && !option.research) {
                continue;
            }
            let searching = this.searchKey ? option.research[this.searchKey] : option.value;
            if (typeof searching == "string") {
                searching = searching?.toLocaleLowerCase();
            }
            if (!searching.includes(value)) {
                continue;
            }
            this.displayedOptions.push(option);
        }
    }
    virtualScrollHeight() {
        const displayedOptionsLength = this.displayedOptions?.length;
        if (!displayedOptionsLength) {
            return 0;
        }
        if (displayedOptionsLength > this.getItemsToEyesNumber()) {
            return 200;
        }
        const height = displayedOptionsLength * (this.itemSize + 5); // +5 for padding
        return height;
    }
    getItemsToEyesNumber() {
        const itemsToEyes = this.virtualScrollConfig.heightPx / this.virtualScrollConfig.minItem;
        return Number(itemsToEyes.toFixed(0));
    }
    loadingLazyPage(firstPage) {
        if (!this.lazy || this.lazyLoadingLimitReached) {
            return;
        }
        this.lazyOnLoadPage?.emit({
            searchValue: this.searchValue,
            firstPage: firstPage
        });
    }
    nextBatch(index) {
        if (!this.lazy) {
            return;
        }
        const displayedOptionsLength = this.displayedOptions?.length;
        const itemsToEyes = this.getItemsToEyesNumber();
        if (!displayedOptionsLength || displayedOptionsLength < itemsToEyes) {
            return;
        }
        if (index == displayedOptionsLength - this.getItemsToEyesNumber() - 1) {
            this.loadingLazyPage(false);
        }
    }
}
VlSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlSelectComponent, selector: "vl-select", inputs: { lazy: "lazy", lazyLoadingFirstPage: "lazyLoadingFirstPage", lazyLoadingNextPage: "lazyLoadingNextPage", lazyLoadingLimitReached: "lazyLoadingLimitReached", disabled: "disabled", multiple: "multiple", status: "status", placeholder: "placeholder", size: "size", selected: "selected", search: "search", searchKey: "searchKey", itemSize: "itemSize", fullWidth: "fullWidth" }, outputs: { selectedChange: "selectedChange", lazyOnLoadPage: "lazyOnLoadPage" }, host: { listeners: { "document:click": "onClick($event)" }, properties: { "class.full": "this.fullWidth" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlSelectComponent),
            multi: true,
        }], queries: [{ propertyName: "customLabel", first: true, predicate: VlSelectLabelComponent, descendants: true }, { propertyName: "inputOptions", predicate: VlSelectOptionComponent }], viewQueries: [{ propertyName: "cdkVirtualScrollViewport", first: true, predicate: ["cdkVirtualScrollViewport"], descendants: true }, { propertyName: "dropdown", first: true, predicate: ["dropdown"], descendants: true }, { propertyName: "button", first: true, predicate: ["button"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<vl-button #button status=\"light\" [size]=\"size\" (onClick)=\"onSelectClick()\" cdkOverlayOrigin #trigger=\"cdkOverlayOrigin\" class=\"!normal-case !w-100\" [disabled]=\"disabled\">\n  <div class=\"flex gap-2 w-full items-center\">\n    <div class=\"flex gap-1 pointer-events-none overflow-hidden whitespace-nowrap\">\n      <ng-content *ngIf=\"customLabel\" select=\"vl-select-label\"></ng-content>\n      <ng-container *ngIf=\"selections?.length; else placeHolderTemplate\">\n        <ng-container *ngFor=\"let option of selections; let isLast = last; \">\n          <ng-container *ngTemplateOutlet=\"option?.template\"></ng-container>\n          <span *ngIf=\"!isLast\">,</span>\n        </ng-container>\n      </ng-container>\n    </div>\n\n    <vl-icon pack=\"font-awesome-solid\" [status]=\"status\" icon=\"angle-down\" class=\"pointer-events-none duration-150 !mr-0 ml-auto\" [ngClass]=\"{'rotate-180 shrink-0': display }\"></vl-icon>\n  </div>\n</vl-button>\n\n<ng-template #placeHolderTemplate>\n  <span [ngClass]=\"{'pl-1': customLabel}\">{{ placeholder }}</span>\n</ng-template>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"trigger\" [cdkConnectedOverlayOpen]=\"isDisplayed\">\n  <!-- [style.width.px]=\"dropdownWidth\" -->\n  <div #dropdown [style.width.px]=\"dropdownWidth\" class=\"z-[80] w-fit text-left mt-1 rounded bg-white border-1 border border-light\">\n    <div *ngIf=\"search\">\n      <vl-search-input [keyup]=\"false\" [enter]=\"true\" [button]=\"true\" (onSearch)=\"onSearch($event)\" [status]=\"status\"></vl-search-input>\n    </div>\n\n    <ul class=\"overflow-y-hidden overflow-x-auto py-1 text-dark relative\" [vlSpinner]=\"lazyLoadingNextPage\" [vlSpinnerStatus]=\"status\" [vlSpinnerBackground]=\"lazyLoadingNextPage ? true:false\">\n      <span *ngIf=\"!lazyLoadingFirstPage && !displayedOptions?.length\" class=\"px-4 py-2 font-medium\">\n        No results\n      </span>\n\n      <vl-spinner-container *ngIf=\"lazyLoadingFirstPage\" size=\"sm\" [status]=\"status\"></vl-spinner-container>\n\n      <cdk-virtual-scroll-viewport #cdkVirtualScrollViewport [itemSize]=\"itemSize\" [style.height.px]=\"virtualScrollHeight()\" (scrolledIndexChange)=\"nextBatch($event)\">\n        <li *cdkVirtualFor=\"let option of displayedOptions; let index = index\" [id]=\"index\" [ngClass]=\"cssClass(option)\" class=\"flex cursor-pointer px-4 py-2 min-w-[120px] whitespace-nowrap\" (click)=\"onSelectChange(option, index)\">\n          <vl-icon *ngIf=\"multiple\" [icon]=\"optionIsSelected(option) ? 'check-square':'square'\" pack=\"font-awesome-regular\" [status]=\"status\" class=\"mr-2\"></vl-icon>\n          <ng-container *ngTemplateOutlet=\"option.template\"></ng-container>\n        </li>\n      </cdk-virtual-scroll-viewport>\n    </ul>\n  </div>\n</ng-template>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content;max-width:25rem}:host ::ng-deep vl-button{width:100%}:host ::ng-deep vl-button button{width:100%;text-transform:none!important}:host.full{max-width:unset;width:100%}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: VlButtonComponent, selector: "vl-button", inputs: ["rounded", "status", "size", "disabled"], outputs: ["onClick"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }, { kind: "directive", type: i1.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "directive", type: i6.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i6.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i6.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "component", type: VlSearchInputComponent, selector: "vl-search-input", inputs: ["disabled", "enter", "keyup", "button", "status", "placeholder", "size", "value"], outputs: ["onSearch"] }, { kind: "directive", type: VlSpinnerDirective, selector: "[vlSpinner]", inputs: ["vlSpinnerStatus", "vlSpinnerSize", "vlSpinnerMessage", "vlSpinnerBackground", "vlSpinnerClass", "vlSpinner"] }, { kind: "component", type: VlSpinnerContainerComponent, selector: "vl-spinner-container", inputs: ["status", "size", "background", "message"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-select', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlSelectComponent),
                            multi: true,
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vl-button #button status=\"light\" [size]=\"size\" (onClick)=\"onSelectClick()\" cdkOverlayOrigin #trigger=\"cdkOverlayOrigin\" class=\"!normal-case !w-100\" [disabled]=\"disabled\">\n  <div class=\"flex gap-2 w-full items-center\">\n    <div class=\"flex gap-1 pointer-events-none overflow-hidden whitespace-nowrap\">\n      <ng-content *ngIf=\"customLabel\" select=\"vl-select-label\"></ng-content>\n      <ng-container *ngIf=\"selections?.length; else placeHolderTemplate\">\n        <ng-container *ngFor=\"let option of selections; let isLast = last; \">\n          <ng-container *ngTemplateOutlet=\"option?.template\"></ng-container>\n          <span *ngIf=\"!isLast\">,</span>\n        </ng-container>\n      </ng-container>\n    </div>\n\n    <vl-icon pack=\"font-awesome-solid\" [status]=\"status\" icon=\"angle-down\" class=\"pointer-events-none duration-150 !mr-0 ml-auto\" [ngClass]=\"{'rotate-180 shrink-0': display }\"></vl-icon>\n  </div>\n</vl-button>\n\n<ng-template #placeHolderTemplate>\n  <span [ngClass]=\"{'pl-1': customLabel}\">{{ placeholder }}</span>\n</ng-template>\n\n<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]=\"trigger\" [cdkConnectedOverlayOpen]=\"isDisplayed\">\n  <!-- [style.width.px]=\"dropdownWidth\" -->\n  <div #dropdown [style.width.px]=\"dropdownWidth\" class=\"z-[80] w-fit text-left mt-1 rounded bg-white border-1 border border-light\">\n    <div *ngIf=\"search\">\n      <vl-search-input [keyup]=\"false\" [enter]=\"true\" [button]=\"true\" (onSearch)=\"onSearch($event)\" [status]=\"status\"></vl-search-input>\n    </div>\n\n    <ul class=\"overflow-y-hidden overflow-x-auto py-1 text-dark relative\" [vlSpinner]=\"lazyLoadingNextPage\" [vlSpinnerStatus]=\"status\" [vlSpinnerBackground]=\"lazyLoadingNextPage ? true:false\">\n      <span *ngIf=\"!lazyLoadingFirstPage && !displayedOptions?.length\" class=\"px-4 py-2 font-medium\">\n        No results\n      </span>\n\n      <vl-spinner-container *ngIf=\"lazyLoadingFirstPage\" size=\"sm\" [status]=\"status\"></vl-spinner-container>\n\n      <cdk-virtual-scroll-viewport #cdkVirtualScrollViewport [itemSize]=\"itemSize\" [style.height.px]=\"virtualScrollHeight()\" (scrolledIndexChange)=\"nextBatch($event)\">\n        <li *cdkVirtualFor=\"let option of displayedOptions; let index = index\" [id]=\"index\" [ngClass]=\"cssClass(option)\" class=\"flex cursor-pointer px-4 py-2 min-w-[120px] whitespace-nowrap\" (click)=\"onSelectChange(option, index)\">\n          <vl-icon *ngIf=\"multiple\" [icon]=\"optionIsSelected(option) ? 'check-square':'square'\" pack=\"font-awesome-regular\" [status]=\"status\" class=\"mr-2\"></vl-icon>\n          <ng-container *ngTemplateOutlet=\"option.template\"></ng-container>\n        </li>\n      </cdk-virtual-scroll-viewport>\n    </ul>\n  </div>\n</ng-template>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content;max-width:25rem}:host ::ng-deep vl-button{width:100%}:host ::ng-deep vl-button button{width:100%;text-transform:none!important}:host.full{max-width:unset;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: VlLayoutService }]; }, propDecorators: { inputOptions: [{
                type: ContentChildren,
                args: [VlSelectOptionComponent]
            }], customLabel: [{
                type: ContentChild,
                args: [VlSelectLabelComponent]
            }], cdkVirtualScrollViewport: [{
                type: ViewChild,
                args: ['cdkVirtualScrollViewport']
            }], dropdown: [{
                type: ViewChild,
                args: ['dropdown']
            }], button: [{
                type: ViewChild,
                args: ['button']
            }], selectedChange: [{
                type: Output
            }], lazyOnLoadPage: [{
                type: Output
            }], lazy: [{
                type: Input
            }], lazyLoadingFirstPage: [{
                type: Input
            }], lazyLoadingNextPage: [{
                type: Input
            }], lazyLoadingLimitReached: [{
                type: Input
            }], disabled: [{
                type: Input
            }], multiple: [{
                type: Input
            }], status: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], size: [{
                type: Input
            }], selected: [{
                type: Input
            }], search: [{
                type: Input
            }], searchKey: [{
                type: Input
            }], itemSize: [{
                type: Input
            }], fullWidth: [{
                type: HostBinding,
                args: ['class.full']
            }, {
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }] } });

class VlSearchInputModule {
}
VlSearchInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlSearchInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputModule, declarations: [VlSearchInputComponent], imports: [CommonModule,
        FormsModule,
        VlIconModule,
        VlInputModule,
        VlButtonModule], exports: [VlSearchInputComponent] });
VlSearchInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputModule, imports: [CommonModule,
        FormsModule,
        VlIconModule,
        VlInputModule,
        VlButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSearchInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        VlIconModule,
                        VlInputModule,
                        VlButtonModule
                    ],
                    declarations: [
                        VlSearchInputComponent
                    ],
                    exports: [
                        VlSearchInputComponent
                    ]
                }]
        }] });

const COMPONENTS$2 = [
    VlSelectComponent,
    VlSelectOptionComponent,
    VlSelectLabelComponent
];
class VlSelectModule {
}
VlSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlSelectModule, declarations: [VlSelectComponent,
        VlSelectOptionComponent,
        VlSelectLabelComponent], imports: [CommonModule,
        VlButtonModule,
        VlIconModule,
        VlCheckboxModule,
        VlInputModule,
        OverlayModule,
        VlSearchInputModule,
        VlSpinnerModule], exports: [VlSelectComponent,
        VlSelectOptionComponent,
        VlSelectLabelComponent] });
VlSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectModule, imports: [CommonModule,
        VlButtonModule,
        VlIconModule,
        VlCheckboxModule,
        VlInputModule,
        OverlayModule,
        VlSearchInputModule,
        VlSpinnerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlButtonModule,
                        VlIconModule,
                        VlCheckboxModule,
                        VlInputModule,
                        OverlayModule,
                        VlSearchInputModule,
                        VlSpinnerModule
                    ],
                    declarations: [
                        ...COMPONENTS$2
                    ],
                    exports: [
                        ...COMPONENTS$2
                    ]
                }]
        }] });

class VlAccordionHeaderComponent {
}
VlAccordionHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlAccordionHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlAccordionHeaderComponent, selector: "vl-accordion-header", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-accordion-header',
                    template: '<ng-content></ng-content>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
class VlAccordionBodyComponent {
}
VlAccordionBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlAccordionBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlAccordionBodyComponent, selector: "vl-accordion-body", ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'vl-accordion-body',
                    template: '<ng-content></ng-content>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }] });
class VlAccordionComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.open = false;
        this.disabled = false;
        this.toogled = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnDestroy() {
    }
    toggle() {
        if (this.disabled) {
            return;
        }
        this.open = !this.open;
        this.toogled.emit(this.open);
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
}
VlAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
VlAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlAccordionComponent, selector: "vl-accordion", inputs: { open: "open", disabled: "disabled" }, outputs: { toogled: "toogled" }, ngImport: i0, template: "<vl-card>\n  <vl-card-header class=\"flex\" [ngClass]=\"{'cursor-pointer': !disabled}\" (click)=\"toggle()\">\n    <ng-content select=\"vl-accordion-header\"></ng-content>\n    <vl-icon *ngIf=\"!disabled\" pack=\"font-awesome-solid\" status=\"dark\" icon=\"angle-down\" size=\"xs\" class=\"pl-4\" class=\"pointer-events-none duration-150 !mr-0 ml-auto !flex items-center\" [ngClass]=\"{'rotate-180 shrink-0': open }\"></vl-icon>\n  </vl-card-header>\n  <vl-card-body [@hightTransition]=\"open ? 'true':'false'\">\n    <ng-content select=\"vl-accordion-body\"></ng-content>\n  </vl-card-body>\n</vl-card>", styles: [":host ::ng-deep vl-card{box-shadow:none}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: VlCardComponent, selector: "vl-card" }, { kind: "component", type: VlCardHeaderComponent, selector: "vl-card-header" }, { kind: "component", type: VlCardBodyComponent, selector: "vl-card-body" }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }], animations: [
        trigger('hightTransition', [
            state('false', style({
                overflow: 'hidden',
                visibility: 'hidden',
                height: 0,
                'padding-top': 0,
                'padding-bottom': 0,
                'flex': '0 0 0',
                opacity: 0
            })),
            state('true', style({
                overflow: 'hidden',
                visibility: 'visible',
            })),
            transition('false => true', animate('100ms ease-in')),
            transition('true => false', animate('100ms ease-out')),
        ])
    ], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-accordion', animations: [
                        trigger('hightTransition', [
                            state('false', style({
                                overflow: 'hidden',
                                visibility: 'hidden',
                                height: 0,
                                'padding-top': 0,
                                'padding-bottom': 0,
                                'flex': '0 0 0',
                                opacity: 0
                            })),
                            state('true', style({
                                overflow: 'hidden',
                                visibility: 'visible',
                            })),
                            transition('false => true', animate('100ms ease-in')),
                            transition('true => false', animate('100ms ease-out')),
                        ])
                    ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vl-card>\n  <vl-card-header class=\"flex\" [ngClass]=\"{'cursor-pointer': !disabled}\" (click)=\"toggle()\">\n    <ng-content select=\"vl-accordion-header\"></ng-content>\n    <vl-icon *ngIf=\"!disabled\" pack=\"font-awesome-solid\" status=\"dark\" icon=\"angle-down\" size=\"xs\" class=\"pl-4\" class=\"pointer-events-none duration-150 !mr-0 ml-auto !flex items-center\" [ngClass]=\"{'rotate-180 shrink-0': open }\"></vl-icon>\n  </vl-card-header>\n  <vl-card-body [@hightTransition]=\"open ? 'true':'false'\">\n    <ng-content select=\"vl-accordion-body\"></ng-content>\n  </vl-card-body>\n</vl-card>", styles: [":host ::ng-deep vl-card{box-shadow:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { open: [{
                type: Input
            }], disabled: [{
                type: Input
            }], toogled: [{
                type: Output
            }] } });

class VlAccordionGroupComponent {
    constructor() {
        this.multiple = false;
        this.destroy$ = new Subject();
        this.accordionToogled$ = new Subject();
    }
    pipe(arg0) {
        throw new Error('Method not implemented.');
    }
    get accordionToogled() {
        return this.accordionToogled$.asObservable();
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        if (this.multiple) {
            return;
        }
        for (let accordion of this.accordions) {
            accordion.toogled
                .pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                if (!value || this.multiple) {
                    return;
                }
                this.closeOtherAccordions(accordion);
            });
        }
        /* merge(...this.accordions.map((target: VlAccordionComponent) => target.toogled))
           .pipe(takeUntil(merge(
             this.destroy$,
           ))).subscribe((value: boolean) => {
             this.accordionToogled$.next();
             //console.log("accordion change", value)
             //for (let accordion of this.accordions) {
             //console.log(accordion);
             /*if (accordion == target || !accordion.opened) {
               continue;
             }
     
             accordion.opened = false;
             //}
           });*/
    }
    closeOtherAccordions(target) {
        for (let accordion of this.accordions) {
            if (target == accordion) {
                continue;
            }
            accordion.open = false;
            accordion.markForCheck();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
VlAccordionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VlAccordionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlAccordionGroupComponent, selector: "vl-accordion-group", inputs: { multiple: "multiple" }, host: { properties: { "class": "this.class" } }, queries: [{ propertyName: "accordions", predicate: VlAccordionComponent, descendants: true }], ngImport: i0, template: '<ng-content select="vl-accordion"></ng-content>', isInline: true, styles: [":host{position:relative;display:block}:host ::ng-deep vl-accordion:not(:last-child)>vl-card{border-bottom:0}:host ::ng-deep vl-accordion:not(:first-child):not(:last-child)>vl-card{border-radius:0}:host ::ng-deep vl-accordion:first-child>vl-card{border-bottom-left-radius:0;border-bottom-right-radius:0}:host ::ng-deep vl-accordion:last-child>vl-card{border-top-left-radius:0;border-top-right-radius:0}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-accordion-group', template: '<ng-content select="vl-accordion"></ng-content>', styles: [":host{position:relative;display:block}:host ::ng-deep vl-accordion:not(:last-child)>vl-card{border-bottom:0}:host ::ng-deep vl-accordion:not(:first-child):not(:last-child)>vl-card{border-radius:0}:host ::ng-deep vl-accordion:first-child>vl-card{border-bottom-left-radius:0;border-bottom-right-radius:0}:host ::ng-deep vl-accordion:last-child>vl-card{border-top-left-radius:0;border-top-right-radius:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { accordions: [{
                type: ContentChildren,
                args: [VlAccordionComponent, { descendants: true }]
            }], multiple: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const COMPONENTS$1 = [
    VlAccordionComponent,
    VlAccordionHeaderComponent,
    VlAccordionBodyComponent,
    VlAccordionGroupComponent
];
class VlAccordionModule {
}
VlAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionModule, declarations: [VlAccordionComponent,
        VlAccordionHeaderComponent,
        VlAccordionBodyComponent,
        VlAccordionGroupComponent], imports: [CommonModule,
        VlCardModule,
        VlIconModule], exports: [VlAccordionComponent,
        VlAccordionHeaderComponent,
        VlAccordionBodyComponent,
        VlAccordionGroupComponent] });
VlAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionModule, imports: [CommonModule,
        VlCardModule,
        VlIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlCardModule,
                        VlIconModule
                    ],
                    declarations: [
                        ...COMPONENTS$1
                    ],
                    exports: [
                        ...COMPONENTS$1
                    ]
                }]
        }] });

class VlTextareaComponent {
    constructor(layoutService) {
        this.layoutService = layoutService;
        this.status = "primary";
        this.size = "base";
        this.placeholder = "";
        this.rows = 2;
        this.keyup = new EventEmitter();
        this.blur = new EventEmitter();
        this.cssColor = {
            "danger": 'hover:border-danger bg-light/50 text-dark',
            "dark": 'hover:border-dark bg-dark/50 text-light',
            "info": 'hover:border-info bg-light/50 text-dark ',
            "light": 'hover:border-light bg-light/50 text-dark',
            "primary": 'hover:border-primary bg-light/50 text-dark',
            "secondary": 'hover:border-econdary bg-light/50 text-dark',
            "success": 'hover:border-success bg-light/50 text-dark',
            "warning": 'hover:border-warning bg-light/50 text-dark'
        };
        this.cssSize = {
            xs: `${PADDING_SIZE['base']} text-[.625rem]`,
            sm: `${PADDING_SIZE['lg']} text-xs`,
            base: `${PADDING_SIZE['xl']} text-sm`,
            lg: `${PADDING_SIZE['xl']} text-base`,
            xl: `${PADDING_SIZE['xl']} text-lg`,
        };
        this.innerValue = '';
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    get wrapperClass() {
        return `${this.cssColor[this.status]} ${this.cssSize[this.size]}`;
    }
    get inputClass() {
        return this.cssSize[this.size];
    }
    get elementRef() {
        return this.textArea;
    }
    get inputValue() {
        return this.innerValue;
    }
    ;
    set inputValue(v) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }
    ngOnInit() {
        this.size = this.layoutService.validateSize(this.size);
        this.status = this.layoutService.validateStatus(this.status);
    }
    onBlur() {
        this.onTouchedCallback();
        this.blur.emit();
    }
    writeValue(value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    ngAfterViewInit() {
        this.textArea.nativeElement.value = this.value;
    }
    onKeyUp(value) {
        if (this.disabled) {
            return;
        }
        this.keyup.emit(value);
    }
}
VlTextareaComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaComponent, deps: [{ token: VlLayoutService }], target: i0.ɵɵFactoryTarget.Component });
VlTextareaComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlTextareaComponent, selector: "vl-textarea", inputs: { status: "status", size: "size", placeholder: "placeholder", value: "value", disabled: "disabled", rows: "rows" }, outputs: { keyup: "keyup", blur: "blur" }, host: { properties: { "class": "this.class" } }, providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VlTextareaComponent),
            multi: true
        }], viewQueries: [{ propertyName: "textArea", first: true, predicate: ["textAreaRef"], descendants: true }], ngImport: i0, template: "<div class=\"relative flex w-full border disabled:opacity-25 rounded items-center duration-300 transition\" [ngClass]=\"wrapperClass\">\n  <textarea #textAreaRef *ngIf=\"value\" [rows]=\"rows\" class=\"w-full outline-none bg-transparent px-[2px]\" [disabled]=\"disabled\" [value]=\"value\" (blur)=\"onBlur()\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\"></textarea>\n  <textarea #textAreaRef *ngIf=\"!value\" [rows]=\"rows\" [(ngModel)]=\"inputValue\" class=\"w-full outline-none bg-transparent px-[2px]\" [disabled]=\"disabled\" (blur)=\"onBlur()\" (keyup)=\"onKeyUp($event)\"></textarea>\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-textarea', providers: [{
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => VlTextareaComponent),
                            multi: true
                        }], template: "<div class=\"relative flex w-full border disabled:opacity-25 rounded items-center duration-300 transition\" [ngClass]=\"wrapperClass\">\n  <textarea #textAreaRef *ngIf=\"value\" [rows]=\"rows\" class=\"w-full outline-none bg-transparent px-[2px]\" [disabled]=\"disabled\" [value]=\"value\" (blur)=\"onBlur()\" [placeholder]=\"placeholder\" (keyup)=\"onKeyUp($event)\"></textarea>\n  <textarea #textAreaRef *ngIf=\"!value\" [rows]=\"rows\" [(ngModel)]=\"inputValue\" class=\"w-full outline-none bg-transparent px-[2px]\" [disabled]=\"disabled\" (blur)=\"onBlur()\" (keyup)=\"onKeyUp($event)\"></textarea>\n</div>" }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }]; }, propDecorators: { textArea: [{
                type: ViewChild,
                args: ['textAreaRef']
            }], status: [{
                type: Input
            }], size: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], rows: [{
                type: Input
            }], keyup: [{
                type: Output
            }], blur: [{
                type: Output
            }], class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class VlTextareaModule {
}
VlTextareaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlTextareaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaModule, declarations: [VlTextareaComponent], imports: [CommonModule,
        FormsModule], exports: [VlTextareaComponent] });
VlTextareaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaModule, imports: [CommonModule,
        FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlTextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    declarations: [
                        VlTextareaComponent
                    ],
                    exports: [
                        VlTextareaComponent
                    ]
                }]
        }] });

class VlMenuComponent {
    constructor(router) {
        this.router = router;
        this.status = "primary";
        this.cssColor = {
            "danger": 'text-danger',
            "dark": 'text-dark',
            "info": 'text-info',
            "light": 'text-light',
            "primary": 'text-primary',
            "secondary": 'text-secondary',
            "success": 'text-success',
            "warning": 'text-warning',
        };
    }
    get cssClass() {
        return `${this.cssColor[this.status]}`;
    }
    ngOnInit() {
    }
    asTemplateRef(item) {
        return typeof item.title == "string" ? false : true;
    }
    onItemClick(item) {
        if (!item.children) {
            return;
        }
        item.expanded = !item.expanded;
    }
    isActiveRoute(item) {
        const link = item.link.replace(/\s/g, "%20");
        const url = this.router.url.replace('/', '');
        if (item.children?.length) {
            return url.includes("#") ? link == url.substring(0, url.indexOf("#")) : link == url;
        }
        if (!link.includes('#') && url.includes("#")) {
            return link == url.substring(0, url.indexOf("#"));
        }
        return link == url;
    }
}
VlMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlMenuComponent, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component });
VlMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlMenuComponent, selector: "vl-menu", inputs: { items: "items", status: "status" }, ngImport: i0, template: "<ng-container *ngTemplateOutlet=\"routingItems; context: {items: items, class:'pt-2'}\"></ng-container>\n\n<ng-template #routingItems let-items=\"items\" let-class=\"class\">\n  <ul class=\"space-y-1 font-medium text-sm\" [ngClass]=\"class\">\n    <li *ngFor=\"let item of items\">\n      <ng-container *ngTemplateOutlet=\"routingItem; context: {item: item}\"></ng-container>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #routingItem let-item=\"item\">\n  \n  <a *ngIf=\"!item.children?.length\" [routerLink]=\"item.link\" [fragment]=\"item.fragment\" [ngClass]=\"isActiveRoute(item) ? cssClass:'text-dark-900'\" class=\"font-semibold flex gap-2 items-center p-2 rounded-lg hover:bg-light cursor-pointer\">\n    <ng-container *ngTemplateOutlet=\"routingItemContent; context: {item: item}\"></ng-container>\n  </a>\n\n  <a *ngIf=\"item.children?.length\" (click)=\"onItemClick(item)\" [ngClass]=\"isActiveRoute(item) ? cssClass:'text-dark-900'\" class=\"font-semibold flex gap-2 items-center p-2 rounded-lg hover:bg-light cursor-pointer\">\n    <ng-container *ngTemplateOutlet=\"routingItemContent; context: {item: item}\"></ng-container>\n  </a>\n\n  <div [@toggle]=\"item.expanded ? 'true':'false'\" class=\"overflow-hidden h-full\" *ngIf=\"item.children?.length\">\n    <ng-container *ngTemplateOutlet=\"routingItems; context: {items: item.children, class: 'pl-3'}\"></ng-container>\n  </div>\n</ng-template>\n\n<ng-template #routingItemContent let-item=\"item\">\n  <vl-icon *ngIf=\"item.icon\" [status]=\"item.icon.status ?? 'dark'\" [icon]=\"item.icon.icon\" [pack]=\"item.icon.pack\"></vl-icon>\n  <span *ngIf=\"!asTemplateRef(item)\">{{ item.title }}</span>\n\n  <ng-container *ngIf=\"asTemplateRef(item)\">\n    <ng-container *ngTemplateOutlet=\"item.title\"></ng-container>\n  </ng-container>\n\n  <vl-icon *ngIf=\"item.children?.length\" [ngClass]=\"{'-rotate-90': item.expanded}\" class=\"ml-auto transition-transform duration-100\" icon=\"angle-left\" pack=\"font-awesome-solid\" status=\"dark\" size=\"sm\"></vl-icon>\n</ng-template>", styles: [":host ul>li>a>vl-icon{width:26px}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }, { kind: "directive", type: i1$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }], animations: [
        trigger('toggle', [
            state("false", style({ height: '0', margin: '0' })),
            state("true", style({ height: '*' })),
            transition(`true <=> false`, animate(100)),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-menu', animations: [
                        trigger('toggle', [
                            state("false", style({ height: '0', margin: '0' })),
                            state("true", style({ height: '*' })),
                            transition(`true <=> false`, animate(100)),
                        ]),
                    ], template: "<ng-container *ngTemplateOutlet=\"routingItems; context: {items: items, class:'pt-2'}\"></ng-container>\n\n<ng-template #routingItems let-items=\"items\" let-class=\"class\">\n  <ul class=\"space-y-1 font-medium text-sm\" [ngClass]=\"class\">\n    <li *ngFor=\"let item of items\">\n      <ng-container *ngTemplateOutlet=\"routingItem; context: {item: item}\"></ng-container>\n    </li>\n  </ul>\n</ng-template>\n\n<ng-template #routingItem let-item=\"item\">\n  \n  <a *ngIf=\"!item.children?.length\" [routerLink]=\"item.link\" [fragment]=\"item.fragment\" [ngClass]=\"isActiveRoute(item) ? cssClass:'text-dark-900'\" class=\"font-semibold flex gap-2 items-center p-2 rounded-lg hover:bg-light cursor-pointer\">\n    <ng-container *ngTemplateOutlet=\"routingItemContent; context: {item: item}\"></ng-container>\n  </a>\n\n  <a *ngIf=\"item.children?.length\" (click)=\"onItemClick(item)\" [ngClass]=\"isActiveRoute(item) ? cssClass:'text-dark-900'\" class=\"font-semibold flex gap-2 items-center p-2 rounded-lg hover:bg-light cursor-pointer\">\n    <ng-container *ngTemplateOutlet=\"routingItemContent; context: {item: item}\"></ng-container>\n  </a>\n\n  <div [@toggle]=\"item.expanded ? 'true':'false'\" class=\"overflow-hidden h-full\" *ngIf=\"item.children?.length\">\n    <ng-container *ngTemplateOutlet=\"routingItems; context: {items: item.children, class: 'pl-3'}\"></ng-container>\n  </div>\n</ng-template>\n\n<ng-template #routingItemContent let-item=\"item\">\n  <vl-icon *ngIf=\"item.icon\" [status]=\"item.icon.status ?? 'dark'\" [icon]=\"item.icon.icon\" [pack]=\"item.icon.pack\"></vl-icon>\n  <span *ngIf=\"!asTemplateRef(item)\">{{ item.title }}</span>\n\n  <ng-container *ngIf=\"asTemplateRef(item)\">\n    <ng-container *ngTemplateOutlet=\"item.title\"></ng-container>\n  </ng-container>\n\n  <vl-icon *ngIf=\"item.children?.length\" [ngClass]=\"{'-rotate-90': item.expanded}\" class=\"ml-auto transition-transform duration-100\" icon=\"angle-left\" pack=\"font-awesome-solid\" status=\"dark\" size=\"sm\"></vl-icon>\n</ng-template>", styles: [":host ul>li>a>vl-icon{width:26px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }]; }, propDecorators: { items: [{
                type: Input
            }], status: [{
                type: Input
            }] } });

class VlMenuModule {
}
VlMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlMenuModule, declarations: [VlMenuComponent], imports: [CommonModule,
        VlIconModule,
        RouterModule], exports: [VlMenuComponent] });
VlMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlMenuModule, imports: [CommonModule,
        VlIconModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlIconModule,
                        RouterModule
                    ],
                    declarations: [
                        VlMenuComponent
                    ],
                    exports: [
                        VlMenuComponent
                    ]
                }]
        }] });

class VlStepComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.active = false;
    }
    ngOnInit() {
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
}
VlStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
VlStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlStepComponent, selector: "vl-step", inputs: { active: "active", id: "id", icon: "icon", pack: "pack", disabled: "disabled" }, ngImport: i0, template: '<ng-content *ngIf="active"></ng-content>', isInline: true, dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-step', template: '<ng-content *ngIf="active"></ng-content>', changeDetection: ChangeDetectionStrategy.OnPush }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { active: [{
                type: Input
            }], id: [{
                type: Input
            }], icon: [{
                type: Input
            }], pack: [{
                type: Input
            }], disabled: [{
                type: Input
            }] } });
class VlStepperComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.status = "primary";
        this.unvalidatedClass = 'bg-secondary-400/50 border-secondary-500/50';
        this.unvalidatedIconStatus = "light";
        this.validatedIconStatus = "light";
        this.validatedIndex = -1;
        this.borderCss = {
            "danger": '!border-danger',
            "dark": '!border-dark',
            "info": '!border-info',
            "light": '!border-light',
            "primary": '!border-primary',
            "secondary": '!border-secondary',
            "success": '!border-success',
            "warning": '!border-warning'
        };
        this.validatedStep = {
            "danger": 'bg-danger',
            "dark": 'bg-dark',
            "info": 'bg-info',
            "light": 'bg-light',
            "primary": 'bg-primary',
            "secondary": 'bg-secondary',
            "success": 'bg-success',
            "warning": 'bg-warning'
        };
    }
    get validatedClass() {
        return `${this.validatedStep[this.status]} ${this.borderCss[this.status]}`;
    }
    get currentStepId() {
        return this.currentStep?.id;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        if (!this.steps?.length) {
            return;
        }
        // Using a timeout, we need this to emit when the components is init on all parent
        setTimeout(() => {
            const activeStep = this.steps?.filter((tab) => tab.active);
            if (!activeStep?.length || activeStep.length > 1) {
                const firstStep = Array.from(this.steps)[0];
                this.currentStep = firstStep;
                this.validatedIndex = 0;
                this.updateStep((tab) => tab.active = tab == firstStep, true);
                this.cdr.markForCheck();
            }
            else {
                this.currentStep = activeStep[0];
                this.validatedIndex = this.getStepIndex(this.currentStep);
                this.updateStep((tab) => tab.active = tab == activeStep[0], true);
                this.cdr.markForCheck();
            }
        });
    }
    isLastStep() {
        if (!this.steps?.length) {
            return false;
        }
        return this.getStepIndex(this.currentStep) == this.steps?.length - 1;
    }
    isFirstStep() {
        if (!this.steps?.length) {
            return false;
        }
        return this.getStepIndex(this.currentStep) == 0;
    }
    invalidateNextStep() {
        const index = this.getStepIndex(this.currentStep);
        this.validatedIndex = index;
    }
    next() {
        if (this.isLastStep()) {
            return;
        }
        const index = this.getStepIndex(this.currentStep);
        const nextIndex = index + 1;
        this.selectStep("id", Array.from(this.steps)[nextIndex]?.id);
        if (nextIndex > this.validatedIndex) {
            this.validatedIndex = nextIndex;
        }
    }
    prev() {
        if (this.isFirstStep()) {
            return;
        }
        const index = this.getStepIndex(this.currentStep);
        const prevIndex = index - 1;
        this.selectStep("id", Array.from(this.steps)[prevIndex]?.id);
    }
    selectStepById(value, invalidate = false) {
        this.selectStep("id", value);
        const index = this.getStepIndex(this.currentStep);
        if (index > this.validatedIndex) {
            this.validatedIndex = index;
        }
        if (invalidate) {
            this.validatedIndex = this.getStepIndex(this.currentStep);
        }
    }
    stepIsAfterCurrentStep(step) {
        const stepIndex = this.getStepIndex(step);
        const currentIndex = this.getStepIndex(this.currentStep);
        return stepIndex <= currentIndex;
    }
    clickOnStep(step) {
        if (!this.stepIsValidated(step) || step.disabled) {
            return;
        }
        this.selectStepById(step.id);
    }
    stepIsValidated(step) {
        const index = this.getStepIndex(step);
        return index <= this.validatedIndex;
    }
    getStepIndex(value) {
        if (!value || !this.steps?.length) {
            return -1;
        }
        return Array.from(this.steps)?.findIndex((step) => step.id == value.id);
    }
    selectStep(by, value) {
        if (!this.steps?.length) {
            return;
        }
        const selectedStep = this.steps.find((step) => step[by] == value);
        if (!selectedStep) {
            return;
        }
        this.currentStep = selectedStep;
        this.updateStep((tab) => tab.active = tab == selectedStep, true);
        this.cdr.markForCheck();
    }
    updateStep(updateFn, markForCheck = false) {
        if (!this.steps) {
            return;
        }
        for (let step of this.steps) {
            updateFn(step);
            if (markForCheck) {
                step.markForCheck();
            }
        }
    }
}
VlStepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepperComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
VlStepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlStepperComponent, selector: "vl-stepper", inputs: { status: "status", unvalidatedClass: "unvalidatedClass", unvalidatedIconStatus: "unvalidatedIconStatus", validatedIconStatus: "validatedIconStatus" }, queries: [{ propertyName: "steps", predicate: VlStepComponent }], ngImport: i0, template: "<div class=\"no-scrollbar overflow-scroll px-[2px] sm:px-0 sm:overflow-visible flex items-center flex-nowrap justify-start gap-4\">\n  <div *ngFor=\"let step of steps; let last = last; let index = index\" class=\"flex items-center\" [ngClass]=\"{'w-full': !last}\">\n    <div class=\"h-12 w-12 shrink-0 mx-[-1px] p-1.5 flex items-center justify-center rounded-full border-2\" [ngClass]=\"[stepIsAfterCurrentStep(step) ? validatedClass : unvalidatedClass, step.disabled ? 'cursor-default':'cursor-pointer']\" (click)=\"clickOnStep(step)\">\n      <vl-icon [icon]=\"step.icon\" size=\"lg\" [pack]=\"step.pack\" [status]=\"stepIsAfterCurrentStep(step) ? validatedIconStatus:unvalidatedIconStatus\"></vl-icon>\n    </div>\n\n    <div *ngIf=\"!last\" class=\"hidden sm:block w-0 sm:w-full h-1 mx-4 rounded-lg\" [ngClass]=\"stepIsAfterCurrentStep(step) ? validatedClass : unvalidatedClass\"></div>\n  </div>\n</div>\n\n<div class=\"stepper-container px-4 pt-6\">\n  <ng-content select=\"vl-step\"></ng-content>\n</div>", styles: [":host{@apply relative flex flex-col;}:host vl-icon{text-align:center}:host .no-scrollbar{scrollbar-width:none;-ms-overflow-style:none}:host .no-scrollbar::-webkit-scrollbar{display:none}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: VlIconComponent, selector: "vl-icon", inputs: ["pack", "icon", "size", "status"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-stepper', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"no-scrollbar overflow-scroll px-[2px] sm:px-0 sm:overflow-visible flex items-center flex-nowrap justify-start gap-4\">\n  <div *ngFor=\"let step of steps; let last = last; let index = index\" class=\"flex items-center\" [ngClass]=\"{'w-full': !last}\">\n    <div class=\"h-12 w-12 shrink-0 mx-[-1px] p-1.5 flex items-center justify-center rounded-full border-2\" [ngClass]=\"[stepIsAfterCurrentStep(step) ? validatedClass : unvalidatedClass, step.disabled ? 'cursor-default':'cursor-pointer']\" (click)=\"clickOnStep(step)\">\n      <vl-icon [icon]=\"step.icon\" size=\"lg\" [pack]=\"step.pack\" [status]=\"stepIsAfterCurrentStep(step) ? validatedIconStatus:unvalidatedIconStatus\"></vl-icon>\n    </div>\n\n    <div *ngIf=\"!last\" class=\"hidden sm:block w-0 sm:w-full h-1 mx-4 rounded-lg\" [ngClass]=\"stepIsAfterCurrentStep(step) ? validatedClass : unvalidatedClass\"></div>\n  </div>\n</div>\n\n<div class=\"stepper-container px-4 pt-6\">\n  <ng-content select=\"vl-step\"></ng-content>\n</div>", styles: [":host{@apply relative flex flex-col;}:host vl-icon{text-align:center}:host .no-scrollbar{scrollbar-width:none;-ms-overflow-style:none}:host .no-scrollbar::-webkit-scrollbar{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { steps: [{
                type: ContentChildren,
                args: [VlStepComponent]
            }], status: [{
                type: Input
            }], unvalidatedClass: [{
                type: Input
            }], unvalidatedIconStatus: [{
                type: Input
            }], validatedIconStatus: [{
                type: Input
            }] } });

const COMPONENTS = [
    VlStepperComponent,
    VlStepComponent
];
class VlStepperModule {
}
VlStepperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlStepperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlStepperModule, declarations: [VlStepperComponent,
        VlStepComponent], imports: [CommonModule,
        VlIconModule], exports: [VlStepperComponent,
        VlStepComponent] });
VlStepperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepperModule, imports: [CommonModule,
        VlIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlStepperModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        VlIconModule
                    ],
                    declarations: [...COMPONENTS],
                    exports: [...COMPONENTS]
                }]
        }] });

class VlAnchorComponent {
    constructor(vlLayoutService, parentRef) {
        this.vlLayoutService = vlLayoutService;
        this.parentRef = parentRef;
        this.type = "_blank";
        this.rounded = true;
        this.status = "primary";
        this.size = "base";
        this.href = "#";
        this.routerLink = "";
        this.routerLinkActive = "";
        this.routerLinkActiveOptions = { exact: false };
        this.queryParams = {};
        this.fragment = "";
        this.cssColor = {
            "danger": 'bg-danger-500 hover:bg-danger-600 text-white',
            "dark": 'bg-dark-500 hover:bg-dark-600 text-white',
            "info": 'bg-info-500 hover:bg-info-600 text-white',
            "light": 'bg-light-500 hover:bg-light-600 text-dark',
            "primary": 'bg-primary-500 hover:bg-primary-600 text-white',
            "secondary": 'bg-secondary-500 hover:bg-secondary-600 text-white',
            "success": 'bg-success-500 hover:bg-success-600 text-white',
            "warning": 'bg-warning-500 hover:bg-warning-600 text-white',
        };
        this.cssSize = {
            xs: `${PADDING_SIZE['xs']} text-xs`,
            sm: `${PADDING_SIZE['sm']} text-sm`,
            base: `${PADDING_SIZE['base']} text-base`,
            lg: `${PADDING_SIZE['lg']} text-lg`,
            xl: `${PADDING_SIZE['xl']} text-lg`,
        };
    }
    get elementRef() {
        return this.aRef;
    }
    get cssClass() {
        return `${this.cssColor[this.status]} ${this.cssSize[this.size]}`;
    }
    ngOnInit() {
        this.size = this.vlLayoutService.validateSize(this.size);
        this.status = this.vlLayoutService.validateStatus(this.status);
    }
}
VlAnchorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorComponent, deps: [{ token: VlLayoutService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
VlAnchorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: VlAnchorComponent, selector: "vl-a", inputs: { type: "type", rounded: "rounded", status: "status", size: "size", href: "href", routerLink: "routerLink", routerLinkActive: "routerLinkActive", routerLinkActiveOptions: "routerLinkActiveOptions", queryParams: "queryParams", fragment: "fragment" }, viewQueries: [{ propertyName: "aRef", first: true, predicate: ["aRef"], descendants: true }], ngImport: i0, template: "<a #aRef *ngIf=\"routerLink\" [routerLink]=\"routerLink\" [routerLinkActive]=\"routerLinkActive\" [routerLinkActiveOptions]=\"routerLinkActiveOptions\" [queryParams]=\"queryParams\" [fragment]=\"fragment\" [type]=\"type\" class=\"disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\">\n   <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</a>\n\n<a #aRef *ngIf=\"!routerLink\" [href]=\"href\" [type]=\"type\" class=\"disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\">\n   <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</a>\n\n<ng-template #content>\n   <ng-content></ng-content>\n</ng-template>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content}:host button{overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1$1.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vl-a', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a #aRef *ngIf=\"routerLink\" [routerLink]=\"routerLink\" [routerLinkActive]=\"routerLinkActive\" [routerLinkActiveOptions]=\"routerLinkActiveOptions\" [queryParams]=\"queryParams\" [fragment]=\"fragment\" [type]=\"type\" class=\"disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\">\n   <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</a>\n\n<a #aRef *ngIf=\"!routerLink\" [href]=\"href\" [type]=\"type\" class=\"disabled:pointer-events-none w-full text-center flex items-center justify-center focus:outline-none focus:ring-0 duration-150 ease-in-out\" [ngClass]=\"[cssClass, rounded ? 'rounded':'']\">\n   <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</a>\n\n<ng-template #content>\n   <ng-content></ng-content>\n</ng-template>", styles: [":host{display:block;position:relative;width:-moz-fit-content;width:fit-content}:host button{overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: VlLayoutService }, { type: i0.ElementRef }]; }, propDecorators: { aRef: [{
                type: ViewChild,
                args: ['aRef']
            }], type: [{
                type: Input
            }], rounded: [{
                type: Input
            }], status: [{
                type: Input
            }], size: [{
                type: Input
            }], href: [{
                type: Input
            }], routerLink: [{
                type: Input
            }], routerLinkActive: [{
                type: Input
            }], routerLinkActiveOptions: [{
                type: Input
            }], queryParams: [{
                type: Input
            }], fragment: [{
                type: Input
            }] } });

class VlAnchorModule {
}
VlAnchorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VlAnchorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorModule, declarations: [VlAnchorComponent], imports: [CommonModule,
        RouterModule], exports: [VlAnchorComponent] });
VlAnchorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorModule, imports: [CommonModule,
        RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: VlAnchorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    declarations: [
                        VlAnchorComponent
                    ],
                    exports: [
                        VlAnchorComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BACKGROUND_COLOR, ContextMenuService, FILL_COLOR, ISize$1 as ISize, IStatus, ITextSize, PADDING_SIZE, TEXT_COLOR, TEXT_SIZE, VL_POPOVER_CONTEXT, VL_WINDOW_CONTEXT, VlAccordionBodyComponent, VlAccordionComponent, VlAccordionGroupComponent, VlAccordionHeaderComponent, VlAccordionModule, VlAnchorComponent, VlAnchorModule, VlBadgeComponent, VlBadgeModule, VlButtonComponent, VlButtonModule, VlCardBodyComponent, VlCardComponent, VlCardFooterComponent, VlCardHeaderComponent, VlCardModule, VlCheckboxComponent, VlCheckboxModule, VlContextMenuComponent, VlContextMenuDirective, VlContextMenuModule, VlIconComponent, VlIconLibraryService, VlIconModule, VlInputComponent, VlInputModule, VlLayoutService, VlListComponent, VlListItemComponent, VlListModule, VlMenuComponent, VlMenuModule, VlPopoverComponent, VlPopoverDirective, VlPopoverModule, VlPopoverRef, VlPopoverService, VlProgressBarComponent, VlProgressBarModule, VlRadioComponent, VlRadioGroupComponent, VlRadioModule, VlSearchInputComponent, VlSearchInputModule, VlSelectComponent, VlSelectLabelComponent, VlSelectModule, VlSelectOptionComponent, VlSpinnerComponent, VlSpinnerContainerComponent, VlSpinnerDirective, VlSpinnerModule, VlStepComponent, VlStepperComponent, VlStepperModule, VlTabComponent, VlTabsComponent, VlTabsModule, VlTemplateRefPipe, VlTextareaComponent, VlTextareaModule, VlTimelineComponent, VlTimelineContentComponent, VlTimelineDateComponent, VlTimelineFooterComponent, VlTimelineItemComponent, VlTimelineModule, VlTimelineTitleComponent, VlToggleComponent, VlToggleModule, VlTooltipComponent, VlTooltipDirective, VlTooltipModule, VlTooltipService, VlTooltiprRef, VlUserComponent, VlUserModule, VlWindowComponent, VlWindowContainerComponent, VlWindowModule, VlWindowRef, VlWindowService };
